<template>
  <div id="components-layout-demo-basic">
    <a-layout>
      <!--   头部   -->
      <a-layout-header style="border-bottom:1px solid #eeeeee;margin-top:10px;">
        <div class="container clearfix" style="position: relative;">
          <!--   Logo   -->
          <router-link tag="a" to="/">
            <div class="logo" style="display: inline-block;height:55px;float:left;padding-top:3px;width:320px;">
              <img src="@/assets/Icons/admin.svg" alt="logo" style="width:38px;height:38px;vertical-align:top;">
              <span style="">Diggo Admin</span>
            </div>
          </router-link>
        </div>
      </a-layout-header>
      <!--   内容   -->
      <a-layout-content>
        <!--   信息页   -->
        <div class="container">
          <div class="admin" style="position:relative;">
            <div style="width:40px;height:40px;border-radius: 50%;cursor: pointer;position:absolute;right:1%;top:-93px;">
              <img :src="avatar" alt="" style="width:100%;height:100%;border-radius: 50%;margin-bottom:23px;">
            </div>
            <div class="admin-menu">
              <!--   切换   -->
              <a-menu
                style="width: 256px"
                :default-selected-keys="defaultShowMenu"
                @click="tabChangeClick">
                <a-menu-item key="1">
                  <img ref="newIcon" src="@/assets/Icons/new.svg" alt="" style="width:24px;height:24px;">
                  <img ref="newIconBlue" src="@/assets/Icons/new-blue.svg" alt="" class="none" style="width:24px;height:24px;">
                  <span>Add New User</span>
                </a-menu-item>
                <a-menu-item key="2">
                  <img ref="historyIcon" src="@/assets/Icons/history.svg" alt="" style="width:24px;height:24px;">
                  <img ref="historyIconBlue" src="@/assets/Icons/history-blue.svg" alt="" class="none" style="width:24px;height:24px;">
                  <span>User Management</span>
                </a-menu-item>
                <a-menu-item key="3">
                  <img ref="claimIcon" src="@/assets/Icons/view-reports.svg" alt="" style="width:24px;height:24px;">
                  <img ref="claimIconBlue" src="@/assets/Icons/view-reports-blue.svg" alt="" class="none" style="width:24px;height:24px;">
                  <span>Claim Management</span>
                </a-menu-item>
                <!-- <a-menu-item key="4">
                  <img ref="workdayIcon" src="@/assets/Icons/balance.svg" alt="" style="width:24px;height:24px;">
                  <img ref="workdayIconBlue" src="@/assets/Icons/balance-blue.svg" alt="" class="none" style="width:24px;height:24px;">
                  <span>Workday Management</span>
                </a-menu-item> -->
                <a-menu-item key="5">
                  <img ref="hardwareIcon" src="@/assets/Icons/device.svg" alt="" style="width:24px;height:24px;">
                  <img ref="hardwareIconBlue" src="@/assets/Icons/device-blue.svg" alt="" class="none" style="width:24px;height:24px;">
                  <span>Hardware Management</span>
                </a-menu-item>
                <a-menu-item key="6">
                  <img ref="atteSummaryIcon" src="@/assets/Icons/attendance_summary.svg" alt="" style="width:24px;height:24px;">
                  <img ref="atteSummaryIconBlue" src="@/assets/Icons/attendance_summary-blue.svg" alt="" class="none" style="width:24px;height:24px;">
                  <span>Attendance Summary</span>
                </a-menu-item>
                <a-menu-item key="7">
                  <img ref="atteRecordIcon" src="@/assets/Icons/attendance_record.svg" alt="" style="width:24px;height:24px;">
                  <img ref="atteRecordIconBlue" src="@/assets/Icons/attendance_record-blue.svg" alt="" class="none" style="width:24px;height:24px;">
                  <span>Daily Attendance Record</span>
                </a-menu-item>
                <!-- <a-menu-item key="6">
                  <img ref="teamIcon" src="@/assets/Icons/team.svg" alt="" style="width:24px;height:24px;">
                  <img ref="teamIconBlue" src="@/assets/Icons/team-blue.svg" alt="" style="width:24px;height:24px;display: none">
                  <span>Server Status</span>
                </a-menu-item> -->
              </a-menu>
            </div>
            <div class="admin-content" style="margin-bottom:30px;">
              <div v-if="adminUserVisible" class="admin-wrap">
                <a-spin :spinning="adminUserLoading">
                  <div class="new-user">
                    <div class="new-user-title" style="z-index: 99">
                      <span class="user-new">Add User</span>
                    </div>
                    <div class="new-user-content-1">
                      <div class="content-item">
                        <span class="item-title">EE Id</span>
                        <a-input v-model="eeId" class="disabled-input" :disabled="true"></a-input>
                      </div>
                      <div class="content-item">
                        <span class="item-title">Legal Name</span>
                        <a-input v-model="legalName" placeholder="Enter Legal Name"></a-input>
                      </div>
                      <div class="content-item">
                        <span class="item-title">User Name</span>
                        <a-input v-model="userName" placeholder="Enter Username"></a-input>
                      </div>
                      <div class="content-item">
                        <span class="item-title">Nick Name</span>
                        <a-input v-model="nickName" placeholder="Enter Nickname"></a-input>
                      </div>
                      <div class="content-item">
                        <span class="item-title">Mobile Number</span>
                        <a-input v-model="mobileNumber" placeholder="Enter Mobile Number"></a-input>
                      </div>
                      <div class="content-item">
                        <span class="item-title">Date Of Birth</span>
                        <a-date-picker @change="onDateOfBirthChange" placeholder="Select Date..." :allowClear="false"/>
                      </div>
                      <div class="content-item">
                        <span class="item-title">Birthday</span>
                        <div style="width:100%;display: flex;">
                          <a-month-picker
                            style="width:35%;margin-right:5%;"
                            format="MMM"
                            :allowClear="false"
                            placeholder="Select Month"
                            @change="onBirthdayMonthChange" />
                          <a-date-picker
                            style="width:35%;margin-right:5%;"
                            format="DD"
                            :allowClear="false"
                            placeholder="Select Date"
                            @change="onBirthdayDateChange" />
                          <a-checkbox class="lunar" @change="onLunarChange">Lunar</a-checkbox>
                        </div>
                      </div>
                      <div class="content-item">
                        <span class="item-title">Native Place</span>
                        <div style="width:100%;display: flex;justify-content: space-between">
                          <a-input style="width:45%;" v-model="nativePlaceProvince" placeholder="Enter Province"></a-input>
                          <span style="width:5%;line-height: 40px;margin-top:10px;text-align: center">-</span>
                          <a-input style="width:45%;" v-model="nativePlaceCity" placeholder="Enter City"></a-input>
                        </div>
                      </div>
                      <div class="content-item">
                        <span class="item-title">Emergence Contact</span>
                        <a-input v-model="emergencyContact" placeholder="Enter Emergence Contact"></a-input>
                      </div>
                      <div class="content-item">
                        <span class="item-title">EE Id</span>
                        <a-input v-model="eeId" class="disabled-input" :disabled="true" ></a-input>
                      </div>
                      <div class="content-item">
                        <span class="item-title">Onboard Date</span>
                        <a-date-picker @change="onBoardDateChange" placeholder="Select Date..." :allowClear="false"/>
                        <img src="@/assets/Icons/time-blue.svg" alt="" style="width:16px;height:16px;position:absolute;right:16px;top:44px;">
                      </div>
                      <div class="content-item">
                        <span class="item-title">Job Title</span>
                        <a-tree-select
                          class="tree-select"
                          style="width: 356px;height:44px;"
                          :dropdown-style="{ maxHeight: '370px', overflow: 'auto' }"
                          placeholder=""
                          :allowClear="false"
                          :value="jobTitleName"
                          tree-default-expand-all
                          @change="onJobTitleChange"
                          :style="{color: jobTitleName === 'Select Type of Job Title' ? '#bbbbbb' : '#000'}"
                        >
                          <a-tree-select-node :selectable="false" v-for="(item) in jobTitleList"
                                              :key="item.id" :value="item.category_code"
                                              :title="item.category_name">
                            <a-tree-select-node v-for="(sonitem) in item.son" :key="sonitem.id"
                                                :value="`${sonitem.category_code},${sonitem.category_name}`"
                                                :title="sonitem.category_name">
                            </a-tree-select-node>
                          </a-tree-select-node>
                        </a-tree-select>
                      </div>
                      <div class="content-item">
                        <span class="item-title">Manage EE Id</span>
                        <a-select placeholder="Select Type of Id" @change="onManageEeIdChange">
                          <!-- <a-select-option :key="1" value="53">Bonnie</a-select-option>
                          <a-select-option :key="2" value="2">Leslie</a-select-option> -->
                          <a-select-option v-for="(item,index) in manageList" :key="index" :value="item.employee_id">{{item.nickname}}</a-select-option>
                          
                        </a-select>
                      </div>
                      <div class="content-item">
                        <span class="item-title">EE Type</span>
                        <a-select placeholder="Select Type" @change="onEeTypeChange">
                          <a-select-option :key="1" :value="0">全职</a-select-option>
                          <a-select-option :key="2" :value="1">坐班实习生</a-select-option>
                          <a-select-option :key="3" :value="2">远程实习生</a-select-option>
                        </a-select>
                      </div>
                      <div class="content-item">
                        <span class="item-title">EE Corporate Entity</span>
                        <a-select placeholder="Select Type" @change="onEmployeeCorpChange">
                          <a-select-option :key="1" :value="0">北京金泰伦</a-select-option>
                          <a-select-option :key="2" :value="1">北京嘀果</a-select-option>
                          <a-select-option :key="3" :value="2">上海嘀果</a-select-option>
                        </a-select>
                      </div>
                      <div class="content-item">
                        <span class="item-title">EE Office</span>
                        <a-select placeholder="Select Type" @change="onEmployeeOfficeChange">
                          <a-select-option :key="1" :value="0">北京</a-select-option>
                          <a-select-option :key="2" :value="1">上海</a-select-option>
                        </a-select>
                      </div>
                      <div class="content-item">
                        <span class="item-title">EE Status</span>
                        <a-input :disabled='true' v-model="eeStatus" ></a-input>
                      </div>
                      <div class="content-item">
                        <span class="item-title">Workday</span>
                        <a-checkbox-group  v-model="workday" @change="onWorkdayChange" style="width:100%;display: flex;justify-content: space-between;">
                          <a-checkbox style="width:20%;" value="1">1</a-checkbox>
                          <a-checkbox style="width:20%;" value="2">2</a-checkbox>
                          <a-checkbox style="width:20%;" value="3">3</a-checkbox>
                          <a-checkbox style="width:20%;" value="4">4</a-checkbox>
                          <a-checkbox style="width:20%;" value="5">5</a-checkbox>
                        </a-checkbox-group>
                      </div>
                       <div class="content-item">
                        <span class="item-title">Reporting Group</span>
                        <a-select placeholder="Select Type of Group" @change="onGroupNewIdChange">
                          <a-select-option v-for="item in groupNewList" :key="item.group_id" :value="item.group_id">{{ item.group_name }}</a-select-option>
                        </a-select>
                      </div>
                      <div class="content-item">
                        <span class="item-title">Work Group</span>
                        <!-- <a-select placeholder="Select Type of Group" @change="onGroupIdChange">
                          <a-select-option v-for="item in groupList" :key="item.group_id" :value="item.group_id">{{ item.group_name }}</a-select-option>
                        </a-select> -->
                         <a-tree-select
                              class="group-tree"
                              :maxTagCount='5'
                              :allowClear='true'
                              v-model="groupId"
                              style="width: 100%"
                              :tree-data="treeData"
                              tree-checkable
                              placeholder="Please select"
                              :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                            >
                            </a-tree-select>
                      </div>
                      
                    </div>
                    <div class="new-user-generate">
                      <a-button @click="userSubmit"><span>提交</span></a-button>
                    </div>
                    <!-- <div class="new-user-generate">
                      <a-button @click="nextOne"><span>下一步</span></a-button>
                    </div> -->
                  </div>
                  <!-- <div v-if="newUserContent2Visible" class="new-user">
                    <div class="new-user-title" style="z-index: 99">
                      <span class="user-new">Add User - Step2</span>
                    </div>
                    <div class="new-user-content-2">
                      <div class="content-item">
                        <span class="item-title">EE Id</span>
                        <a-input v-model="eeId" class="disabled-input" :disabled="true" ></a-input>
                      </div>
                      <div class="content-item">
                        <span class="item-title">Onboard Date</span>
                        <a-date-picker @change="onBoardDateChange" placeholder="Select Date..." :allowClear="false"/>
                        <img src="@/assets/Icons/time-blue.svg" alt="" style="width:16px;height:16px;position:absolute;right:16px;top:44px;">
                      </div>
                      <div class="content-item">
                        <span class="item-title">Job Title</span>
                        <a-tree-select
                          class="tree-select"
                          style="width: 356px;height:44px;"
                          :dropdown-style="{ maxHeight: '370px', overflow: 'auto' }"
                          placeholder=""
                          :allowClear="false"
                          :value="jobTitleName"
                          tree-default-expand-all
                          @change="onJobTitleChange"
                          :style="{color: jobTitleName === 'Select Type of Job Title' ? '#bbbbbb' : '#000'}"
                        >
                          <a-tree-select-node :selectable="false" v-for="(item) in jobTitleList"
                                              :key="item.id" :value="item.category_code"
                                              :title="item.category_name">
                            <a-tree-select-node v-for="(sonitem) in item.son" :key="sonitem.id"
                                                :value="`${sonitem.category_code},${sonitem.category_name}`"
                                                :title="sonitem.category_name">
                            </a-tree-select-node>
                          </a-tree-select-node>
                        </a-tree-select>
                      </div>
                      <div class="content-item">
                        <span class="item-title">Manage EE Id</span>
                        <a-select placeholder="Select Type of Id" @change="onManageEeIdChange">
                          <a-select-option :key="1" value="53">Bonnie</a-select-option>
                          <a-select-option :key="2" value="2">Leslie</a-select-option>
                        </a-select>
                      </div>
                      <div class="content-item">
                        <span class="item-title">EE Type</span>
                        <a-select placeholder="Select Type" @change="onEeTypeChange">
                          <a-select-option :key="1" :value="0">全职</a-select-option>
                          <a-select-option :key="2" :value="1">坐班实习生</a-select-option>
                          <a-select-option :key="3" :value="2">远程实习生</a-select-option>
                        </a-select>
                      </div>
                      <div class="content-item">
                        <span class="item-title">EE Status</span>
                        <a-input :disabled='true' v-model="eeStatus" ></a-input>
                      </div>
                      <div class="content-item">
                        <span class="item-title">Workday</span>
                        <a-checkbox-group  v-model="workday" @change="onWorkdayChange" style="width:100%;display: flex;justify-content: space-between;">
                          <a-checkbox style="width:20%;" value="1">1</a-checkbox>
                          <a-checkbox style="width:20%;" value="2">2</a-checkbox>
                          <a-checkbox style="width:20%;" value="3">3</a-checkbox>
                          <a-checkbox style="width:20%;" value="4">4</a-checkbox>
                          <a-checkbox style="width:20%;" value="5">5</a-checkbox>
                        </a-checkbox-group>
                      </div>
                      <div class="content-item">
                        <span class="item-title">Group</span>
                        <a-select placeholder="Select Type of Group" @change="onGroupIdChange">
                          <a-select-option v-for="item in groupList" :key="item.group_id" :value="item.group_id">{{ item.group_name }}</a-select-option>
                        </a-select>
                      </div>
                    </div>
                    <div class="new-user-generate">
                      <a-button @click="previousStep"><span>上一步</span></a-button>
                      <a-button @click="userSubmit"><span>提交</span></a-button>
                    </div>
                  </div> -->
                </a-spin>
              </div>
              <div v-if="adminStatusVisible" class="admin-status-wrap user-management">
                <div class="user-status-title" style="z-index: 99">
                  <span class="user-new">User Management</span>
                  <span class="user-history">{{ allUserInfoNum }} in Total</span>
                </div>
                <div class="user-status-content" style="height:100%;">
                  <span style="display:inline-block;width:60px;">Status: </span>
                  <a-radio-group v-model="userStatusFilter" @change="onUserStatusChange" style="margin-bottom:10px;">
                    <a-radio value="All">全部</a-radio>
                    <a-radio value="0">在职</a-radio>
                    <a-radio value="1">离职</a-radio>
                  </a-radio-group>
                  <br>
                  <span style="display:inline-block;width:60px;">Type: </span>
                  <a-radio-group v-model="userTypeFilter" @change="onUserTypeChange" style="margin-bottom:10px;">
                    <a-radio value="All">全部</a-radio>
                    <a-radio value="0">全职</a-radio>
                    <a-radio value="1">坐班实习</a-radio>
                    <a-radio value="2">远程实习</a-radio>
                  </a-radio-group>
                  <br>
                  <!-- <a-checkbox-group class="filter-checkbox-wrap" v-model="userFliter" @change="onAllUserChange">
                    <div style="display:flex;width:100%;">
                      <a-checkbox value="全部" class="filter-checkbox-item">全部</a-checkbox>
                      <a-checkbox value="在职" class="filter-checkbox-item">在职</a-checkbox>
                      <a-checkbox value="离职" class="filter-checkbox-item">离职</a-checkbox>
                      <a-checkbox value="全职" class="filter-checkbox-item">全职</a-checkbox>
                      <a-checkbox value="坐班实习" class="filter-checkbox-item">坐班实习</a-checkbox>
                      <a-checkbox value="远程实习" class="filter-checkbox-item">远程实习</a-checkbox>
                    </div>
                  </a-checkbox-group> -->
                  <span style="display:inline-block;width:60px;">Group: </span>
                  <a-radio-group v-model="userGroupFilter" @change="onAllUserGroupChange">
                    <a-radio value="All">All</a-radio>
                    <a-radio v-for="item in this.groupNewList" :key="item.id" :value="item.group_id">{{item.group_name}}</a-radio>
                  </a-radio-group>
                  <a-table
                    style="margin-top:10px;"
                    :loading="userTableLoading"
                    :columns="columns" 
                    :data-source="allUserInfo"  
                    :rowKey="record => record.id"
                    :pagination="false"
                  >
                    <span slot="name" slot-scope="text">{{text == '张银花' ? 'Tina' : text}}</span>
                    <span slot="group" slot-scope="text"><span style="margin-right:10px;" v-for="item in text" :key='item.group_id'>{{ item.group_name.split(" ")[1] }}</span></span>
                    <span slot="group_new" slot-scope="text">{{ text.length == 0 ? '' : text[0].group_name.split(" ")[1] }}</span>
                    <span slot="ee_type" slot-scope="text" v-html="text == '0' ? '全职' : text == '1' ? '坐班实习生' : '远程实习生'"></span>
                    <span slot="ee_status" slot-scope="text" v-html="text == '0' ? '在职' : '离职'"></span>
                    <span slot="workday" slot-scope="text"><span style="margin-right:5px;" v-for="(item,index) in text.split(',').sort()" :key='index'>{{ item }}</span></span>
                    <span slot="edit" slot-scope="text,record"><a @click="userInfoChange(record)">Edit</a></span>
                  </a-table>
                  <a-modal
                    width="850px"
                    title="Edit"
                    :visible="changeModalVisible"
                    :confirm-loading="changeConfirmLoading"
                    @ok="infoChangeOk"
                    @cancel="infoChangeCancel"
                  >
                    <div class="change-item">
                      <span style="width:156px;margin-right:30px;">Name:</span>
                      <div style="width:100%;margin-left:-6px;">{{ legalNameChange }}</div>
                    </div>
                    <div class="change-item">
                      <span style="width:156px;margin-right:30px;">Reporting Group:</span>
                        <a-radio-group :value="groupNewChange" @change="groupNewInfoChange" style="width:100%;display: flex;margin-left:-46px;">
                          <a-radio v-for="item in this.groupNewList" :key="item.id" :value="item.group_id" style="margin-left:33px;">{{item.group_name.split(" ")[1]}}</a-radio>
                        </a-radio-group>
                    </div>
                    <div class="change-item">
                      <span style="width:156px;margin-right:30px;">Work Group:</span>
                      <a-checkbox-group :value="groupChange" @change="groupInfoChange" style="width:100%;display: flex;justify-content: space-between;margin-left:-6px;">
                        <a-checkbox v-for="item in this.groupList" :key="item.id" :value="item.group_id" style="width:12%;margin-left:0;">{{item.group_name.split(' ')[1]}}</a-checkbox>
                      </a-checkbox-group>
                    </div>
                    <div class="change-item">
                      <span style="width:120px;margin-right:30px;">Job Title:</span>
                      <a-tree-select
                        class="tree-select"
                        style="width: 400px;height:30px;"
                        :dropdown-style="{ maxHeight: '370px', overflow: 'auto' }"
                        placeholder=""
                        :allowClear="false"
                        :value="jobTitleNameChange"
                        tree-default-expand-all
                        @change="jobTitleInfoChange"
                      >
                        <a-tree-select-node :selectable="false" v-for="(item) in jobTitleList"
                                            :key="item.id" :value="item.category_code"
                                            :title="item.category_name">
                          <a-tree-select-node v-for="(sonitem) in item.son" :key="sonitem.id"
                                              :value="`${sonitem.category_code},${sonitem.category_name}`"
                                              :title="sonitem.category_name">
                          </a-tree-select-node>
                        </a-tree-select-node>
                      </a-tree-select>
                    </div>
                    <!-- manager_ee_id -->
                     <div class="change-item" v-if="legalNameChange!='李政坤'&&legalNameChange!='张艺腾'">
                      <span style="width:120px;margin-right:30px;">Manager EE Id:</span>
                      <a-select :value="managerEeIdChange" @change="managerEeIdInfoChange" style="width:400px;height:30px;">
                        <a-select-option v-for="(item, index) in manageList" :key="index" :value="item.employee_id">
                          {{ item.nickname }}
                        </a-select-option>
                      </a-select>
                      <!-- <a-select :options="manageList" :value="managerEeIdChange" @change="managerEeIdInfoChange" style="width:400px;height:30px;"></a-select> -->
                    </div>
                    <div class="change-item">
                      <span style="width:120px;margin-right:30px;">EE Type:</span>
                      <a-select :value="eeTypeChange == '0' ? '全职' : eeTypeChange == '1' ? '坐班实习生' : '远程实习生'" @change="eeTypeInfoChange" style="width:400px;height:30px;">
                        <a-select-option :key="1" :value="0">全职</a-select-option>
                        <a-select-option :key="2" :value="1">坐班实习生</a-select-option>
                        <a-select-option :key="3" :value="2">远程实习生</a-select-option>
                      </a-select>
                    </div>
                    <div class="change-item">
                      <span style="width:120px;margin-right:30px;">EE Corporate Entity:</span>
                      <a-select :value="employee_corp_change == '0' ? '北京金泰伦' : employee_corp_change == '1' ? '北京嘀果' : '上海嘀果'" @change="employeeCorpInfoChange" style="width:400px;height:30px;">
                        <a-select-option :key="1" :value="0">北京金泰伦</a-select-option>
                        <a-select-option :key="2" :value="1">北京嘀果</a-select-option>
                        <a-select-option :key="3" :value="2">上海嘀果</a-select-option>
                      </a-select>
                    </div>
                    <div class="change-item">
                      <span style="width:120px;margin-right:30px;">EE Office:</span>
                      <a-select :value="employee_office_change == '0' ? '北京' : '上海'" @change="employeeOfficeChange" style="width:400px;height:30px;">
                        <a-select-option :key="1" :value="0">北京</a-select-option>
                        <a-select-option :key="3" :value="1">上海</a-select-option>
                      </a-select>
                    </div>
                    <div class="change-item">
                      <span style="width:120px;margin-right:30px;">EE Status:</span>
                      <a-select :value="eeStatusChange == '0' ? '在职' : '离职'" @change="eeStatusInfoChange" style="width:400px;height:30px;">
                        <a-select-option :key="1" :value="0">在职</a-select-option>
                        <a-select-option :key="2" :value="1">离职</a-select-option>
                      </a-select>
                    </div>
                    <div class="change-item">
                      <span style="width:120px;margin-right:30px;">Workday:</span>
                      <a-checkbox-group :value="workdayChange" @change="workdayInfoChange" style="width:400px;display: flex;justify-content: space-between">
                        <a-checkbox style="width:20%;" value="1">1</a-checkbox>
                        <a-checkbox style="width:20%;" value="2">2</a-checkbox>
                        <a-checkbox style="width:20%;" value="3">3</a-checkbox>
                        <a-checkbox style="width:20%;" value="4">4</a-checkbox>
                        <a-checkbox style="width:20%;" value="5">5</a-checkbox>
                      </a-checkbox-group>
                    </div>
                    <div class="change-item">
                      <span style="width:120px;margin-right:30px;">Resignation Date:</span>
                      <a-date-picker
                        @change="onResignationDateChange"
                        :value="onResignationDate"
                        placeholder="Select Date..."
                        :disabled="onResignationDateStatus"
                        style="width:400px;height:30px;"
                        :allowClear="false"
                      />
                    </div>
                  </a-modal>
                </div>
              </div>
              <div v-if="adminClaimVisible" class="admin-status-wrap">
                  <div class="user-status-title" style="z-index: 99">
                    <span class="user-new">Claim Management</span>
                    <span class="user-history" style="display:flex;align-items:center;">
                      <a-button :disabled="invoiceExportStatus" icon="download" @click="invoiceExport2Excel" class="export-btn">导出</a-button>
                      <a-select
                            class="year-select"
                            style="margin-right:0;"
                            v-model="yearValue"
                            @change="yearChange"
                          >

                          <a-select-option v-for="item in yearList" :key="item" :value="item">{{item}}</a-select-option>
                        </a-select>
                      <span>{{ allInvoiceNum }} in Total</span>
                    </span>
                  </div>
                  <div class="user-status-content">
                    <a-radio-group name="radioGroup" v-model="invoiceStatus" @change="invoiceStatusChange">
                      <a-radio :value="1">
                        待审批
                      </a-radio>
                      <a-radio :value="2">
                        已通过
                      </a-radio>
                      <a-radio :value="4">
                        已打款
                      </a-radio>
                      <a-radio :value="3">
                        已拒绝
                      </a-radio>
                      <a-radio :value="5">
                        已驳回
                      </a-radio>
                    </a-radio-group>
                    <div class="view-report-content">
                      <a-table
                        class="claim-management"
                        style="margin-top:20px;width:100%;"
                        :loading="claimTableLoading"
                        :expandIconAsCell='false'
                        :expandIconColumnIndex="6"
                        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
                        :columns="invoiceColumns"
                        :data-source="allInvoiceList"
                        :rowKey="(record) => record.rb_number"
                        :customRow="Rowclick"
                        :pagination="false"
                        :scroll="{ y: 680 }"
                      >
                        <span slot="rb_number" slot-scope="text"><span style="font-family:GoogleSans-Bold;color:#222222;">No.{{ text }}</span></span>
                        <span slot="category_name" slot-scope="text"><span style="font-family:GoogleSans-Regular;color:#222222;">{{ text }}</span></span>
                        <span slot="rb_name" slot-scope="text"><span style="font-family:GoogleSans-Regular;color:#999999;">{{ text }}</span></span>
                        <span slot="legal_name" slot-scope="text"><span style="font-family:GoogleSans-Regular;color:#000000;">{{ text == '张银花' ? 'Tina' : text }}</span></span>
                        <span slot="sum" slot-scope="text"><span style="font-family:GoogleSans-Regular;color:#000000;">￥{{ text }}</span></span>
                        <a-table
                          class="innerTable"
                          :showHeader='false'
                          slot="expandedRowRender"
                          slot-scope="record"
                          :columns="invoiceInnerColumns"
                          :data-source="record.detail"
                          :rowKey="(record,index) => index"
                          :pagination="false"
                        >
                          <span slot="invoice_amount" slot-scope="text">
                            <span style="font-family:GoogleSans-Regular;color:#000000;">
                              ￥{{ parseFloat(text).toFixed(2).split('.')[0].replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') + '.' + parseFloat(text).toFixed(2).split('.')[1] }}
                            </span>
                          </span>
                        </a-table>
                      </a-table>
                    </div>
                  </div>
                  <div style="height:85px;width:100%;display:flex;justify-content:flex-start;padding-left:32px;align-items:center;border-top:1px solid #eeeeee;position:relative;">
                    <a-popconfirm
                      :disabled='invoiceOperateBtn'
                      title="提交后将通过该报销申请，是否继续提交？"
                      ok-text="确认"
                      cancel-text="取消"
                      @confirm="invoiceStatusChangeConfirm(2)"
                      @cancel="invoiceOperateCancel"
                    >
                      <a-button v-if="invoiceStatus == 1" type="primary" :disabled="invoiceOperateBtn" class="invoice-submit-btn">通过</a-button>
                    </a-popconfirm>
                    <a-popconfirm :disabled='true'>
                      <a-button v-if="invoiceStatus == 1" type="danger" :disabled="invoiceOperateBtn" @click="invoiceRefuse" class="invoice-submit-btn">拒绝</a-button>
                    </a-popconfirm>
                    <a-input 
                      v-if="reasonVisible" 
                      v-model="reasonContent"
                      placeholder="请输入拒绝理由"
                      style="margin-right:32px;"
                    >
                    </a-input>
                    <a-popconfirm
                      title="提交后将拒绝该报销申请，是否继续提交？"
                      ok-text="确认"
                      cancel-text="取消"
                      @confirm="invoiceStatusChangeConfirm(3)"
                      @cancel="invoiceOperateCancel"
                    >
                      <a-button v-if="reasonVisible" type="primary" style="margin-right:32px;position:absolute;right:0;">确认</a-button>
                    </a-popconfirm>
                    <a-popconfirm
                      :disabled='invoiceOperateBtn'
                      title="提交后不可撤回或修改，是否继续提交？"
                      ok-text="确认"
                      cancel-text="取消"
                      @confirm="invoiceStatusChangeConfirm(4)"
                      @cancel="invoiceOperateCancel"
                    >
                      <a-button v-if="invoiceStatus == 2" type="primary" :disabled="invoiceOperateBtn" class="invoice-submit-btn">财务已打款</a-button>
                    </a-popconfirm >
                    <a-popconfirm :disabled='true'>
                      <a-button v-if="invoiceStatus == 2" type="danger" :disabled="invoiceOperateBtn" @click="invoiceReject" class="invoice-submit-btn">财务已驳回</a-button>
                    </a-popconfirm>
                    <a-input 
                      v-if="rejectReasonVisible" 
                      v-model="rejectReasonContent"
                      placeholder="请输入拒绝理由"
                      style="margin-right:32px;"
                    >
                    </a-input>
                    <a-popconfirm
                      title="提交后将拒绝该报销申请，是否继续提交？"
                      ok-text="确认"
                      cancel-text="取消"
                      @confirm="invoiceStatusChangeConfirm(5)"
                      @cancel="invoiceOperateCancel"
                    >
                      <a-button v-if="rejectReasonVisible" type="primary" style="margin-right:32px;position:absolute;right:0;">确认</a-button>
                    </a-popconfirm>
                  </div>
              </div>
              <div v-if="adminWorkdayVisible" class="admin-status-wrap">
                  <div class="user-status-title" style="z-index: 99">
                    <span class="user-new">Workday Management</span>
                    <span class="user-history">
                      <a-button :disabled="workdayExportStatus" icon="download" @click="workdayExport2Excel" class="export-btn">导出</a-button>
                      <a-month-picker style="width:85px;border-radius:6px;" :default-value="moment(monthDate, monthFormat)" :format="monthFormat" @change="workdayMonthChange"/>
                    </span>
                  </div>
                  <div class="user-status-content" style="height:auto;">
                    <a-radio-group name="radioGroup" v-model="workdayStatus" @change="workdayStatusChange">
                      <div>
                        <a-radio :value="1" style="margin-right:50px;">
                          所有请假
                        </a-radio>
                        <a-radio :value="2" style="margin-right:70px;">
                          年假
                        </a-radio>
                        <a-radio :value="3" style="margin-right:50px;">
                          病假
                        </a-radio>
                        <a-radio :value="4" style="margin-right:50px;">
                          事假
                        </a-radio>
                        <a-radio :value="5" style="margin-right:50px;">
                          事假（实习生）
                        </a-radio>
                      </div>
                      <div style="margin-top:20px;">
                        <a-radio :value="6" style="margin-right:50px;">
                          所有外出
                        </a-radio>
                        <a-radio :value="7" style="margin-right:42px;">
                          因公外出
                        </a-radio>
                        <a-radio :value="8" style="margin-right:50px;">
                          团建
                        </a-radio>
                        <a-radio :value="9" style="margin-right:42px;">
                          居家办公
                        </a-radio>
                      </div>
                    </a-radio-group>
                    <div class="view-report-content">
                      <!-- 请假表格 -->
                      <a-table
                        v-show="holidayStatus == 'leave'"
                        style="margin-top:20px;"
                        :loading="workdayTableLoading"
                        :columns="workdaycolumns"
                        :data-source="leaveList"
                        :rowKey="record => record.id"
                        :pagination="false"
                      >
                        <span slot="name" slot-scope="text">{{text == '张银花' ? 'Tina' : text}}</span>
                        <span slot="operation" slot-scope="text,record">
                          <a-popconfirm
                            title="删除后不可撤销，是否继续提交？"
                            ok-text="确认"
                            cancel-text="取消"
                            @confirm="outDelete(record.id)"
                            @cancel="invoiceOperateCancel"
                          >
                            <a>Delete</a>
                          </a-popconfirm>
                        </span>
                      </a-table>
                      <!-- 外出表格 -->
                      <a-table
                        v-show="holidayStatus == 'out'"
                        style="margin-top:20px;"
                        :loading="workdayTableLoading"
                        :columns="outColumns"
                        :data-source="outList"
                        :rowKey="record => record.id"
                        :pagination="false"
                      >
                        
                        <span slot="participants" slot-scope="participants" class="participants">
                          <a-tooltip style="width:1000px;" :overlayStyle="tooltipWidth">
                            <template slot="title">
                              <span v-for="(part,index) in participants" :key="index" class="participants-item">{{part == '张银花' ? 'Tina' : part}}</span>
                            </template>
                            <span>
                              <span v-for="(part,index) in participants" :key="index" class="participants-item">{{part == '张银花' ? 'Tina' : part}}</span>
                            </span>
                          </a-tooltip>
                            
                        </span>
                        <span slot="operation" slot-scope="text,record">
                          <a-popconfirm
                            title="删除后不可撤销，是否继续提交？"
                            ok-text="确认"
                            cancel-text="取消"
                            @confirm="outDelete(record.id)"
                            @cancel="invoiceOperateCancel"
                          >
                            <a>Delete</a>
                          </a-popconfirm>
                        </span>
                      </a-table>
                    </div>
                  </div>
              </div>
              <div v-if="adminHardwareVisible" class="admin-status-wrap"> 
                  <div class="user-status-title" style="z-index: 99">
                    <span class="user-new">Hardware Management</span>
                  </div>
                  <div class="user-status-content" style="height:auto;">
                    <div class="view-report-content">
                      <span style="font-family: GoogleSans-Bold;font-size: 18px;">Add New Device</span>
                      <div style="display:flex;flex-wrap:wrap;justify-content:space-between;">
                        <div class="content-item" style="width:30%;margin-top:15px;display:flex;flex-direction:column;">
                          <span class="item-title">Name</span>
                          <a-auto-complete
                            class="auto-name"
                            v-model="hardwareName"
                            style=""
                            placeholder="Search Name"
                            spellcheck="false"
                            @select="onNameSelect"
                            @change="onNameChange"
                          >
                            <template slot="dataSource">
                              <a-select-option 
                                  v-for="item in searchList" 
                                  :key="item.employee_id"
                                  :value="`${item.employee_id},${item.legal_name}`">
                                <img v-if="item.profile_picture" :src="item.profile_picture" alt="" style="width:40px;height:40px;border-radius:50%;">
                                <img v-else src="@/assets/Images/defaultavatar.jpeg" alt="" style="width:40px;height:40px;border-radius:50%;">
                                <span style="margin-left:12px;">{{ item.legal_name }}</span>
                              </a-select-option>
                            </template>
                            <a-input style="margin-top:2px; width:100%;">
                            </a-input>
                          </a-auto-complete>
                        </div>
                        <div class="content-item" style="width:31%;margin-top:15px;">
                          <span class="item-title">Device Model</span>
                          <a-input v-model="deviceModal"></a-input>
                        </div>
                        <div class="content-item" style="width:31%;margin-top:15px;">
                          <span class="item-title">Serial Number</span>
                          <a-input v-model="serialNumber"></a-input>
                        </div>
                        <div class="content-item" style="width:30%;margin-top:15px;">
                          <span class="item-title">Distribution Time</span>
                          <a-date-picker @change="distributionTimeChange" placeholder="Select Date..." :allowClear="false"/>
                        </div>
                        <div class="content-item" style="width:31%;margin-top:15px;">
                          <span class="item-title">Memory</span>
                          <a-input v-model="memory"></a-input>
                        </div>
                        <div class="content-item" style="width:31%;margin-top:15px;">
                          <span class="item-title">Storage</span>
                          <a-input v-model="storage"></a-input>
                        </div>
                      </div>
                      <div style="text-align:right;">
                        <a-button style="margin-top:20px;height:40px;border-radius:8px;" type="primary" @click="diviceSubmit">+ Add a Device</a-button>
                      </div>
                      <div class="view-report-content" style="display:flex;justify-content:space-between;margin-top:40px;">
                        <span style="font-family: GoogleSans-Bold;font-size: 18px;">Hardware Status</span>
                        <span class="user-history" style="margin-right:0;">
                        {{hardwareListLength}} in Total
                        </span>
                      </div>
                      <a-table
                        style="margin-top:20px;"
                        :loading="hardwareTableLoading"
                        :columns="hardwareColumns"   
                        :data-source="hardwareList"
                        :rowKey="record => record.id"
                        :pagination="false"
                      >
                      <span slot="name" slot-scope="text">
                        <span v-if="text!=''&&text!=null">{{text == '张银花' ? 'Tina' : text}}</span>
                        <span v-else>-</span>
                      </span>
                      <span slot="operation" slot-scope="text,record">
                        <a @click="userHandwareChange(record)">Edit</a>
                        <a-popconfirm
                          title="是否回收该设备？"
                          ok-text="确认"
                          cancel-text="取消"
                          @confirm="userHandwareRetrieve(record)"
                          @cancel="invoiceOperateCancel"
                        >
                          <a style="margin-left:15px;">Retrieve</a>
                        </a-popconfirm>
                        <a-popconfirm
                          title="删除后不可撤销，是否继续提交？"
                          ok-text="确认"
                          cancel-text="取消"
                          @confirm="userHandwareDelete(record.id)"
                          @cancel="invoiceOperateCancel"
                        >
                          <a style="margin-left:15px;">Delete</a>
                        </a-popconfirm>
                      </span>
                      <span slot="employee_id" slot-scope="text">
                        <span v-if="text!=''&&text!=null">{{text}}</span>
                        <span v-else>-</span>
                      </span>
                      <span slot="distribution_time" slot-scope="text">
                        <span v-if="text!=''&&text!=null">{{text}}</span>
                        <span v-else>-</span>
                      </span>
                      <span slot="time" slot-scope="text,record" :style="{color:((Math.abs(new Date() - new Date(record.distribution_time)) / (1000*60*60*24)) / 365).toFixed(2) > 4 ? 'red' : ''}">
                        <span v-if="record.distribution_time!=''&&record.distribution_time!=null">{{ ((Math.abs(new Date() - new Date(record.distribution_time)) / (1000*60*60*24)) / 365).toFixed(2) }}</span>
                        <span v-else>-</span>
                        
                        <!-- {{ Math.floor((Math.abs(new Date() - new Date(record.distribution_time)) / (1000*60*60*24)).toFixed() / 365)}} -->
                        <!-- {{ (((Math.floor(Math.abs(new Date() - new Date(record.distribution_time)) / (1000*60*60*24))).toFixed() - Math.floor((Math.abs(new Date() - new Date(record.distribution_time)) / (1000*60*60*24)).toFixed() / 365) * 365) / 365).toFixed(2) }} -->
                        <!-- {{ Math.floor((Math.abs(new Date() - new Date(record.distribution_time)) / (1000*60*60*24)).toFixed() / 365) == 0 ? '' : Math.floor((Math.abs(new Date() - new Date(record.distribution_time)) / (1000*60*60*24)).toFixed() / 365) + ' years '}}{{ (Math.floor(Math.abs(new Date() - new Date(record.distribution_time)) / (1000*60*60*24))).toFixed() - Math.floor((Math.abs(new Date() - new Date(record.distribution_time)) / (1000*60*60*24)).toFixed() / 365) * 365 + ' days'}}  -->
                      </span>
                      
                      </a-table>
                      <a-modal
                        width="700px"
                        title="Edit"
                        :visible="hardwareChangeStatus"
                        :confirm-loading="hardwareChangeConfirmLoading"
                        @ok="hardwareChangeOk"
                        @cancel="hardwareChangeCancel"
                      >
                        <div style="display:flex;flex-wrap:wrap;justify-content:space-between;">
                        <div class="content-item" style="width:24%;">
                          <span class="item-title">Id</span>
                          <a-input v-model="handwareOnlyIdChange" :disabled='true' style="margin-top:10px;"></a-input>
                        </div>
                        <div class="content-item" style="width:24%;display:flex;flex-direction:column;">
                          <span class="item-title">Name</span>
                          <a-auto-complete
                            class="auto-name"
                            v-model="hardwareNameChange"
                            style=""
                            placeholder="Search Name"
                            spellcheck="false"
                            @select="onChangeNameSelect"
                            @change="onNameChange"
                          >
                            <template slot="dataSource">
                              <a-select-option 
                                  v-for="item in searchList" 
                                  :key="item.employee_id"
                                  :value="`${item.employee_id},${item.legal_name}`">
                                <img v-if="item.profile_picture" :src="item.profile_picture" alt="" style="width:40px;height:40px;border-radius:50%;">
                                <img v-else src="@/assets/Images/defaultavatar.jpeg" alt="" style="width:40px;height:40px;border-radius:50%;">
                                <span style="margin-left:12px;">{{ item.legal_name }}</span>
                              </a-select-option>
                            </template>
                            <a-input style="margin-top:10px; width:100%;">
                            </a-input>
                          </a-auto-complete>
                        </div>
                        <div class="content-item" style="width:48%;display:flex;flex-direction:column;">
                          <span class="item-title">Distribution Time</span>
                          <a-date-picker :value="distributionTimeContentChange" @change="distributionTimeUpdate" placeholder="Select Date..." :allowClear="false" style="margin-top:10px;"/>
                        </div>
                        <div class="content-item" style="width:50%;margin-top:15px;">
                          <span class="item-title">Device Model</span>
                          <a-input v-model="deviceModalChange" style="margin-top:10px;"></a-input>
                        </div>
                        <div class="content-item" style="width:48%;margin-top:15px;">
                          <span class="item-title">Serial Number</span>
                          <a-input v-model="serialNumberChange" style="margin-top:10px;"></a-input>
                        </div>
                        <div class="content-item" style="width:50%;margin-top:15px;">
                          <span class="item-title">Memory</span>
                          <a-input v-model="memoryChange" style="margin-top:10px;"></a-input>
                        </div>
                        <div class="content-item" style="width:48%;margin-top:15px;">
                          <span class="item-title">Storage</span>
                          <a-input v-model="storageChange" style="margin-top:10px;"></a-input>
                        </div>
                      </div>
                      </a-modal>
                    </div>
                  </div>
              </div>
              <div v-if="adminAttSumVisible" class="admin-status-wrap" style="max-width: 100%;">
                <div class="user-status-title" style="z-index: 99">
                  <span class="user-new">Attendance Summary</span>
                  <span class="user-history">
                      <a-button icon="download" @click="attSummaryByYearExport2Excel" class="export-btn">导出全年数据</a-button>
                      <a-button icon="download" @click="attSummaryExport2Excel" class="export-btn">导出当月数据</a-button>
                      <a-month-picker style="width:85px;border-radius:6px;" :default-value="moment(monthPreviewDate, monthFormat)" :format="monthFormat" @change="attSumMonthChange"/>
                    </span>
                </div>
                <div class="user-status-content" style="height:auto;max-width: 100%;">
                  <div class="view-report-content">
                    <a-table
                        style="margin-top:20px;"
                        :loading="attSumTableLoading"
                        :columns="attSumColumns"
                        :data-source="attSumList"
                        :rowKey="record => record.employee_id"
                        :pagination="false"
                    >
                      <div slot="ee_type"  slot-scope="text">{{ text == 0 ? 'FTE' : 'Intern' }}</div>
                      <span slot="percent" slot-scope="text,record" style="font-family: GoogleSans-Bold;color:#001df5;">{{ isNaN((record.normal / (record.work_days - record.business - record.annual_days) * 100).toFixed(0)) ? '-' : (record.normal / (record.work_days - record.business - record.annual_days) * 100).toFixed(0) + '%'}}</span>
                      <span slot="correctPercent" slot-scope="text,record" style="font-family: GoogleSans-Bold;color:#001df5;">{{ isNaN((record.normal / record.must_attendance * 100).toFixed(0)) ? '-' : (record.normal / record.must_attendance * 100).toFixed(0) + '%'}}</span>
                      <!-- <span slot="normal" slot-scope="text,record">{{record.must_attendance - record.late - record.early - record.less_on - record.less_out}}</span> -->
                      <span slot="less" slot-scope="text,record">{{record.less_on + record.less_out}}</span>
                      <span slot="absent" slot-scope="text,record">{{record.business + record.leave}}</span>
                      
                      
                      <span slot="daily" slot-scope="text,record" style="font-family: GoogleSans-Bold;color:#001df5;">{{isNaN(record.hour / (record.normal + record.late + record.early)) ? '-' : (record.hour / (record.normal + record.late + record.early)).toFixed(1)}}</span>

                    </a-table>
                  </div>
                </div>
              </div>
              <div v-if="adminAttDayVisible" class="admin-status-wrap" style="max-width: 99%;">
                <div class="user-status-title" style="z-index: 99">
                  <span class="user-new">Daily Attendance Record</span>
                  <span class="user-history">
                    <a-button icon="download" @click="attRecordExport2Excel" class="export-btn">导出</a-button>
                    <a-month-picker style="width:85px;border-radius:6px;" :default-value="moment(monthPreviewDate, monthFormat)" :format="monthFormat" @change="attDayMonthChange"/>
                  </span>
                </div>
                <div class="user-status-content" style="height:auto;">
                  <div class="view-report-content">
                    <a-table
                        style="margin-top:20px;"
                        :loading="attDayTableLoading"
                        :columns="attDayColumns"
                        :data-source="attDayList"
                        :scroll="{x:2100}"
                        :rowKey="record => record.employee_id"
                        :pagination="false"
                    >
                      <div slot="ee_type"  slot-scope="text">{{ text == 0 ? 'FTE' : 'Intern' }}</div>
                      <div
                          v-for="(item,index) in dateList"
                          :slot=item
                          slot-scope="text,record"
                          :key="index"
                          :style="{
                            padding:'12px',
                            background: record.attendance.filter(single => { return single[item] == item })[0] && record.attendance.filter(single => { return single[item] == item })[0].status === 1 ? '#bdd5ac' : // 请假
                                        record.attendance.filter(single => { return single[item] == item })[0] && record.attendance.filter(single => { return single[item] == item })[0].status === 5 ? '#f1cca2' : // 早退
                                        record.attendance.filter(single => { return single[item] == item })[0] && record.attendance.filter(single => { return single[item] == item })[0].status === 6 ? '#f1cca2' : // 迟到
                                        record.attendance.filter(single => { return single[item] == item })[0] && record.attendance.filter(single => { return single[item] == item })[0].status === 2 ? '#aac2f0' : // 外出
                                        record.attendance.filter(single => { return single[item] == item })[0] && record.attendance.filter(single => { return single[item] == item })[0].status === 3 ? '#aac2f0' : // 团建
                                        record.attendance.filter(single => { return single[item] == item })[0] && record.attendance.filter(single => { return single[item] == item })[0].status === 4 ? '#e6d2db' : // 居家
                                        record.attendance.filter(single => { return single[item] == item })[0] && record.attendance.filter(single => { return single[item] == item })[0].status === 10 ? '#dd9d9b' : // 矿工
                                        record.attendance.filter(single => { return single[item] == item })[0] && record.attendance.filter(single => { return single[item] == item })[0].status === 7 ? '#fae5a2' : // 上班缺卡
                                        record.attendance.filter(single => { return single[item] == item })[0] && record.attendance.filter(single => { return single[item] == item })[0].status === 8 ? '#fae5a2' : // 下班缺卡
                                        record.attendance.filter(single => { return single[item] == item })[0] && record.attendance.filter(single => { return single[item] == item })[0].status === 12 ? '#afdfe4' : // 其他
                                        record.attendance.filter(single => { return single[item] == item })[0] && record.attendance.filter(single => { return single[item] == item })[0].status === 11 ? '#e3b2d8' : 'transparent' // 病假
                          }"
                      >
                        <div>
                          {{
                            record.attendance.filter(single => {
                              return single[item] == item
                            })[0]
                            && record.attendance.filter(single => {
                              return single[item] == item
                            })[0].status_msg
                          }}
                        </div>
                        <div
                          v-if="
                            !((record.attendance.filter(single => {
                              return single[item] == item
                            })[0] && record.attendance.filter(single => {
                              return single[item] == item
                            })[0].check_time_on == '-') &&
                            (record.attendance.filter(single => {
                              return single[item] == item
                            })[0] && record.attendance.filter(single => {
                              return single[item] == item
                            })[0].check_time_off == '-'))
                          "
                        >
                          {{
                            record.attendance.filter(single => {
                              return single[item] == item
                            })[0] && '(' + record.attendance.filter(single => {
                              return single[item] == item
                            })[0].check_time_on.slice(0,5) + ','
                          }}
                          {{
                            record.attendance.filter(single => {
                              return single[item] == item
                            })[0] && record.attendance.filter(single => {
                              return single[item] == item
                            })[0].check_time_off.slice(0,5) + ')'
                          }}
                        </div>
                      </div>
                    </a-table>
                  </div>
                </div>
              </div>
              <!-- <div v-if="adminServiceVisible" class="admin-status-wrap">
                  <div class="user-status-title" style="z-index: 99">
                    <span class="user-new">Service Status</span>
                  </div>
                  <div class="user-status-content" style="height:auto;">
                    <div style="width:100%;margin-bottom:24px;;display:flex;justify-content:flex-end;">
                      <a-date-picker style="width:140px;" :default-value="serviceDate" @change="onDateChange" />
                    </div>
                    <a-table
                    class="service-table"
                    style="margin-top:10px;"
                    :loading="serviceStatusLoading"
                    :columns="serviceStatusColumns" 
                    :data-source="allServiceStatus"  
                    :pagination="false"
                    :rowKey="(record) => record.id"
                  >
                    </a-table>
                  </div>
              </div>  -->
<!--              <div v-if="workTablevVisible">-->
<!--                <a-select-->
<!--                    class="year-select"-->
<!--                    style="margin-right:0;margin-bottom:24px;"-->
<!--                    v-model="yearValue"-->
<!--                    @change="yearChange"-->
<!--                  >-->
<!--                    <a-select-option value="2023">2023</a-select-option>-->
<!--                    <a-select-option value="2022">2022</a-select-option>-->
<!--                </a-select>-->
<!--                  <a-table-->
<!--                    :columns="workdayColumns"-->
<!--                    :data-source="workdayList"-->
<!--                    :rowKey="(record,index) => index"-->
<!--                    :pagination="false"-->
<!--                  >-->
<!--                  -->
<!--                    <span slot="last_num" slot-scope="text,record"><span>{{ Number(record.initial_al) - Number(record.used_al) }}</span></span>-->
<!--                  </a-table>-->
<!--              </div>-->
            </div>
          </div>
        </div>
      </a-layout-content>
    </a-layout>
    <Bug></Bug>
  </div>
</template>

<script>
import moment from 'moment'
import api from '@/common/api.js'
import Bug from '../../components/Bug.vue'
// import Blob from "@/excel/Blob.js"
// import Export2Excel from "@/excel/Export2Excel.js"

moment.suppressDeprecationWarnings = true
const workColumns = [
  {
    title: 'Id',
    dataIndex: 'employee_id',
    width:70,
    align: 'center',
    sorter: (a, b) => {
      return a.employee_id - b.employee_id
    },
  },
  {
    title: 'Name',
    dataIndex: 'legal_name',
    width:80,
    align: 'center',
    scopedSlots: { customRender: 'name' },
  },
  {
    title: 'Onboard Date',
    dataIndex: 'onboard_date',
    width:150,
    sorter: (a, b) => {
      return a.onboard_date.localeCompare(b.onboard_date)
    },
  },
  {
    title: 'Reporting Group',
    dataIndex: 'group_new',
    scopedSlots: { customRender: 'group_new' },
    width:120,
    align: 'center' 
  },
  {
    title: 'Work Group',
    dataIndex: 'group',
    scopedSlots: { customRender: 'group' },
    width:120,
    align: 'center',
  },
  {
    title: 'Job Title',
    dataIndex: 'job_title',
    width:270,
    sorter: (a, b) => {
      return a.job_title.localeCompare(b.job_title)
    },
  },
  {
    title: 'Type',
    dataIndex: 'ee_type',
    scopedSlots: { customRender: 'ee_type' },
    width:120,
    align: 'center',
    sorter: (a, b) => {
      return a.ee_type.localeCompare(b.ee_type)
    },
  },
  {
    title: 'Status',
    dataIndex: 'ee_status',
    align: 'center',
    scopedSlots: { customRender: 'ee_status' },
  },
  {
    title: 'Workday',
    dataIndex: 'workday',
    scopedSlots: { customRender: 'workday' },
    width:120,
    align: 'center'
  },
  {
    title: 'Edit',
    key: 'edit',
    align: 'center',
    scopedSlots: { customRender: 'edit' },
  },
]
const workdayColumns = [
    {
      title: 'ID',
      dataIndex: 'employee_id',
      align: 'center',
    },
    {
      title: 'Name',
      dataIndex: 'nickname',
      align: 'center',
    },
    {
      title: '年假结余',
      dataIndex: 'last_num',
      scopedSlots: { customRender: 'last_num' },
      align: 'center',
    },
    {
      title: '已用年假',
      dataIndex: 'used_al',
      align: 'center',
    },
     {
      title: '已用病假',
      dataIndex: 'used_sl',
      align: 'center',
    },
     {
      title: '已用事假',
      dataIndex: 'used_ol',
      align: 'center',
    },
     {
      title: '因公外出',
      dataIndex: 'business',
      align: 'center',
    },
     {
      title: '在家办公',
      dataIndex: 'home',
      align: 'center',
    },
    {
      title: '团建',
      dataIndex: 'building',
      align: 'center',
    },
    {
      title: '当前新增年假',
      dataIndex: 'al_added_this_year',
      align: 'center',
    },
]
const resignColumns = [
  {
    title: 'Id',
    dataIndex: 'employee_id',
    width:70,
    align: 'center',
    sorter: (a, b) => {
      return a.id - b.id
    },
  },
  {
    title: 'Name',
    dataIndex: 'legal_name',
    width:80,
    align: 'center',
    scopedSlots: { customRender: 'name' },
  },
  {
    title: 'Onboard Date',
    dataIndex: 'onboard_date',
    width:150,
    sorter: (a, b) => {
      return a.onboard_date.localeCompare(b.onboard_date)
    },
  },
  {
    title: 'Resignation Date',
    dataIndex: 'resignation_date',
    width:150,
    align: 'center'
  },
  {
    title: 'Reporting Group',
    dataIndex: 'group_new',
    scopedSlots: { customRender: 'group_new' },
    width:120,
    align: 'center' 
  },
  {
    title: 'Work Group',
    dataIndex: 'group',
    scopedSlots: { customRender: 'group' },
    width:120,
    align: 'center' 
  },
   
  {
    title: 'Job Title',
    dataIndex: 'job_title',
    width:270,
    sorter: (a, b) => {
      return a.job_title.localeCompare(b.job_title)
    },
  },
  {
    title: 'Type',
    dataIndex: 'ee_type',
    scopedSlots: { customRender: 'ee_type' },
    width:120,
    align: 'center',
    sorter: (a, b) => {
      return a.ee_type.localeCompare(b.ee_type)
    },
  },
  {
    title: 'Status',
    dataIndex: 'ee_status',
    align: 'center',
    scopedSlots: { customRender: 'ee_status' },
  },
  {
    title: 'Workday',
    dataIndex: 'workday',
    scopedSlots: { customRender: 'workday' },
    width:120,
    align: 'center'
  },
  {
    title: 'Edit',
    key: 'edit',
    align: 'center',
    scopedSlots: { customRender: 'edit' },
  },
]
const invoiceColumns = [
  {
    title: '报销序号',
    dataIndex: 'rb_number',
    scopedSlots: { customRender: 'rb_number' },
    width:100,
    sorter: (a, b) => {
      return a.rb_number.localeCompare(b.rb_number);
    },
  },
  {
    title: '报销类型',
    dataIndex: 'category_name',
    scopedSlots: { customRender: 'category_name' },
    width:120,
    sorter: (a, b) => {
      return a.category_name.localeCompare(b.category_name);
    },
  },
  {
    title: '类型编码',
    dataIndex: 'category_code',
    scopedSlots: { customRender: 'category_code' },
    width:80,
    sorter: (a, b) => {
      return a.category_code.localeCompare(b.category_code);
    },
  },
  {
    title: '报销单名称',
    dataIndex: 'rb_name',
    scopedSlots: { customRender: 'rb_name' },
    width:120,
  },
  {
    title: '申请人',
    dataIndex: 'legal_name',
    scopedSlots: { customRender: 'legal_name' },
    width:60,
  },
  {
    title: '金额',
    dataIndex: 'sum',
    scopedSlots: { customRender: 'sum' },
    width:100,
    align:'right'
  },
  {
    width:40,
  },
]
const invoiceInnerColumns = [
  {
    width:60,
  },
  { 
    title: '序号', 
    dataIndex: 'id',
    customRender: (text, record, index) => `${index + 1}`, 
    width: 120,
    align:'center' 
  },
  { 
    title: '发票日期', 
    dataIndex: 'invoice_date', 
    width: 150 
  },
  { 
    title: '发票类型', 
    dataIndex: 'invoice_name',
    width: 150
  },
  { 
    title: '费用详情', 
    dataIndex: 'comments', 
    width: 130
  },
  { 
    title: '金额', 
    dataIndex: 'invoice_amount', 
    scopedSlots: { customRender: 'invoice_amount' }, 
    width: 100, 
    align:'right' 
  },
  {
    width:40,
  },
]
const leaveColumns = [
  {
    title: 'Name',
    dataIndex: 'legal_name',
    scopedSlots: { customRender: 'name' },
    sorter: (a, b) => {
      return a.legal_name.localeCompare(b.legal_name);
    },
  },
  {
    title: 'Type of Leave/Out',
    dataIndex: 'leave_cat_name_chn',
    sorter: (a, b) => {
      return a.leave_cat_name_chn.localeCompare(b.leave_cat_name_chn);
    },
    width:200,
    align:'center'
  },
  {
    title: 'StartDate',
    dataIndex: 'leave_startdate',
    // customRender: (text, record) => `${record.leave_startdate} ~ ${record.leave_enddate}`, 
    sorter: (a, b) => {
      return a.leave_startdate.localeCompare(b.leave_startdate);
    },
    align:'center',
  },
  {
    title: 'EndDate',
    dataIndex: 'leave_enddate',
    sorter: (a, b) => {
      return a.leave_enddate.localeCompare(b.leave_enddate);
    },
    align:'center'
  },
  {
    title: 'Days',
    dataIndex: 'leave_days',
    sorter: (a, b) => {
      return a.leave_days - b.leave_days;
    },
    align:'center'
  },
]
const outColumns = [
  {
    title: 'Name',
    dataIndex: 'participants',
    scopedSlots: { customRender: 'participants' },
    width:180
  },
  {
    title: 'Type of Leave/Out',
    dataIndex: 'out_cat_name_chn',
    sorter: (a, b) => {
      return a.out_cat_name_chn.localeCompare(b.out_cat_name_chn);
    },
    width:200,
    align:'center'
  },
  {
    title: 'StartDate',
    dataIndex: 'out_startdate',
    // customRender: (text, record) => `${record.out_startdate} ~ ${record.out_enddate}`, 
    sorter: (a, b) => {
      return a.out_startdate.localeCompare(b.out_startdate);
    },
    align:'center',
  },
  {
    title: 'EndDate',
    dataIndex: 'out_enddate',
    sorter: (a, b) => {
      return a.out_enddate.localeCompare(b.out_enddate);
    },
    align:'center'
  },
  {
    title: 'Days',
    dataIndex: 'out_days',
    sorter: (a, b) => {
      return a.leave_days - b.leave_days;
    },
    align:'center'
  },
  {
    title: 'Action',
    align: 'center',
    scopedSlots: { customRender: 'operation' },
  }
]
const hardwareColumns = [
  {
    title: 'Device Model',
    dataIndex: 'device_model',
    sorter: (a, b) => {
      return a.device_model.localeCompare(b.device_model)
    },
  },
  {
    title: 'Serial Number',
    dataIndex: 'serial_number',
    align: 'center',
    sorter: (a, b) => {
      return a.serial_number.localeCompare(b.serial_number)
    },
  },
  {
    title: 'Memory',
    dataIndex: 'memory',
  },
  {
    title: 'Storage',
    dataIndex: 'storage',
    align: 'center',
    sorter: (a, b) => {
      return a.storage.localeCompare(b.storage)
    },
  },
  {
    title: 'Employee ID',
    dataIndex: 'employee_id',
    scopedSlots: { customRender: 'employee_id' },
    sorter: (a, b) => {
      return a.employee_id - b.employee_id;
    },
  },
  {
    title: 'Name',
    dataIndex: 'legal_name',
    width:90,
    scopedSlots: { customRender: 'name' },
     filters: [
      {
        text: '空',
        value: '',
      },
      {
        text: '非空',
        value: '-',
      },
    ],
    onFilter: (value, record) => {
      if (value === ''|| value === null) {
        return record.legal_name === ''|| record.legal_name === null;
      } else {
        return record.legal_name !== ''&& record.legal_name !== null;
      }
    },
  },
  {
    title: 'Distribution Time',
    dataIndex: 'distribution_time',
    scopedSlots: { customRender: 'distribution_time' },
    width:150,
    sorter: (a, b) => {
      return a.distribution_time.localeCompare(b.distribution_time)
      // return a.distribution_time - b.distribution_time
    },
  },
  {
    title:'Hold Time (Year)',
    scopedSlots: { customRender: 'time' },
    width:120,
    sorter: (a, b) => {
      return a.distribution_time.localeCompare(b.distribution_time)
    },
  },
  {
    title: 'Action',
    key: 'operation',
    align: 'center',
    scopedSlots: { customRender: 'operation' },
  },
]
const serviceStatusColumns = [
  {
    title: 'Site',
    dataIndex: 'domain',
    filters:[],
    onFilter: (value, record) => record.domain.indexOf(value) === 0,
  },
  // {
  //   title: 'IP',
  //   dataIndex: 'ip',
  //   width:200,
  // },
  {
    title: 'Group',
    dataIndex: 'groups',
    width:120,
    filters:[],
    defaultFilteredValue:['4'],
    onFilter: (value, record) => record.groups.indexOf(value) === 0,
  },
  {
    title: 'Ping Date',
    dataIndex: 'ping_date',
    width:120,
  },
  {
    title: 'Ping Time',
    dataIndex: 'ping_time',
    width:120,
  },
  {
    title: 'Ping Hour',
    dataIndex: 'ping_hour',
    width:120,
    filters:[],
    defaultFilteredValue:[],
    onFilter: (value, record) => record.ping_hour.indexOf(value) === 0,
  },
  {
    title: 'Ping Result',
    dataIndex: 'result',
  },
]
const treeData = []
const attSumColumns = [
  {
    title: '姓名',
    dataIndex: 'legal_name',
    align: 'center',
    width:120,
  },
  {
    title: '月份',
    dataIndex: 'month',
    align: 'center',
    width:120,
  },
  // {
  //   title: 'FTE/Intern',
  //   dataIndex: 'ee_type',
  //   align: 'center',
  //   width:120,
  //   scopedSlots: { customRender: 'ee_type' },
  // },
  // {
  //   title: '出勤率',
  //   dataIndex: 'percent',
  //   scopedSlots: { customRender: 'percent' },
  //   align: 'center',
  // },

  // {
  //   title: '正常打卡率',
  //   dataIndex: 'correctPercent',
  //   scopedSlots: { customRender: 'correctPercent' },
  //   align: 'center',
  // },
  // {
  //   title: '工作日',
  //   dataIndex: 'work_days',
  //   align: 'center',
  // },
  // {
  //   title: '出勤',
  //   dataIndex: 'must_attendance',
  //   align: 'center',
  // },
  {
    title: '正常',
    dataIndex: 'normal',
    scopedSlots: { customRender: 'normal' },
    align: 'center',
  },
  {
    title: '迟到',
    dataIndex: 'late',
    align: 'center',
  },
  {
    title: '早退',
    dataIndex: 'early',
    align: 'center',
  },
  {
    title: '缺卡',
    dataIndex: 'less',
    scopedSlots: { customRender: 'less' },
    align: 'center',
  },
  // {
  //   title: '未出勤',
  //   dataIndex: 'absent',
  //   scopedSlots: { customRender: 'absent' },
  //   align: 'center',
  // },
  // {
  //   title: 'a.因公不在',
  //   dataIndex: 'business',
  //   align: 'center',
  // },
  {
    title: '外出',
    dataIndex: 'out',
    align: 'center',
  },
  {
    title: '团建',
    dataIndex: 'teambuilding',
    align: 'center',
  },
  {
    title: 'WFH',
    dataIndex: 'wfh',
    align: 'center',
  },
  // {
  //   title: 'b.因私不在',
  //   dataIndex: 'leave',
  //   align: 'center',
  // },
  {
    title: '病假',
    dataIndex: 'sick_days',
    align: 'center',
  },
  {
    title: '年假',
    dataIndex: 'annual_days',
    align: 'center',
  },
  {
    title: '其他假',
    dataIndex: 'other_days',
    align: 'center',
  },

  {
    title: '打卡总时长（分钟）',
    dataIndex: 'duration',
    align: 'center',
    sorter: (a, b) => {
      return a.duration - b.duration;
    },
  },
  {
    title: '日平均工时',
    dataIndex: 'daily',
    align: 'center',
    scopedSlots: { customRender: 'daily' },
  },

  // {
  //   title: '旷工天数',
  //   dataIndex: 'miner',
  //   align: 'center',
  // },
 
  // {
  //   title: '应打卡天数',
  //   dataIndex: 'must_attendance',
  //   align: 'center',
  // },
  // {
  //   title: '工作工时（小时）',
  //   dataIndex: 'hour',
  //   align: 'center',
  // },
  // {
  //   title: '工时修正',
  //   dataIndex: '',
  //   align: 'center',
  // },
 
]

export default {
  name: 'Leave',
  components: {
    Bug
  },
  data() {
    return {
      attSumList:[],
      attDayList:[],
      attSumColumns,
      attDayColumns:[],
      workdayColumns,
      workdayList:[],
      treeData,                                             //  树选择数据
      workColumns,                                    //  不带离职
      resignColumns,                                  //  带离职
      invoiceColumns,                                 //  报销单
      invoiceInnerColumns,                            //  发票内部详情
      leaveColumns,                                   //  假期列表
      outColumns,                                     //  外出列表
      hardwareColumns,                                //  硬件列表
      serviceStatusColumns,
      todayDate: moment()                             //  今天日期
      .format('MM-DD-YYYY')
      .slice(0, 10),
      monthDate:moment()                              //  今月
      .format('YYYY/MM'),
      monthPreviewDate:moment()                       //  上个月
      .subtract(1,'month')
      .format('YYYY-MM'),
      monthFormat:'YYYY/MM',
      filterUser:'2',                                 //  人员过滤参数1 2 3 
      adminUserVisible: true,                         //  员工录入页面显示
      newUserContent1Visible: true,                   //  第一个提交页显示
      newUserContent2Visible: false,                  //  第二个提交页显示
      adminStatusVisible: false,                      //  状态管理页面显示
      adminClaimVisible:false,                        //  发票报销页面显示     
      adminWorkdayVisible: false,                     //  假期管理页面显示
      adminHardwareVisible: false,                    //  硬件管理页面显示
      adminServiceVisible:false,                      //  服务器状态页面显示
      adminAttSumVisible:false,                       //  考勤汇总记录
      adminAttDayVisible:false,                       //  日常打卡记录
      adminUserLoading: false,                        //  添加人员页面加载状态
      userTableLoading:false,                         //  人员管理页面表格加载状态
      claimTableLoading:false,                        //  发票管理页面表格加载状态
      workdayTableLoading:false,                      //  假期管理页面表格加载状态
      hardwareTableLoading:false,                     //  硬件管理页面表格加载状态
      serviceStatusLoading:false,
      attSumTableLoading:false,
      attDayTableLoading:false,
      avatar: '',                                     //  当前员工头像
      groupList:'',                                   //  所有组信息
      jobTitleList:'',                                //  职位列表
      allUserInfoList:[],                             //  所有人员列表
      // userFliter:['全部','在职'],                      //  默认过滤条件
      userGroupFilter:'All',
      userStatusFilter:"All",
      userTypeFilter:"All", 
      allUserInfo:[],                                 //  过滤后人员列表
      
      // 提交个人资料 第一步
      eeId: '',                                       //  员工id
      legalName: '',                                  //  法定姓名
      userName: '',                                   //  姓名拼音
      nickName: '',                                   //  昵称
      mobileNumber: '',                               //  手机号码
      dateOfBirth: '',                                //  身份证生日
      birthdayMonth: '',                              //  想过的生日-月份
      birthdayDate: '',                               //  想过的生日-日期
      birthdayLunar: '',                              //  阴历阳历
      birthday: '',                                   //  想过的生日
      nativePlaceProvince: '',                        //  省份
      nativePlaceCity: '',                            //  城市
      nativePlace: '',                                //  家乡
      emergencyContact: '',                           //  紧急联系人手机号
      // 提交个人资料 第二步
      onBoardDate: '',                                //  入职时间
      jobTitleId: '',                                 //  职位id
      jobTitleName:'Select Type of Job Title',        //  职位名字
      managerEeId: '',                                //  管理员id
      eeType: '',                                     //  工作类型
      employee_corp:'',
      employee_office:'',                              //  办公地点
      eeStatus: '0',                                  //  工作状态
      workday: ['1','2','3','4','5'],                 //  工作日
      groupId: [],                                    //  分组id
      groupNewId:'',
      manageList:'',                                  //  负责人列表
      managerEeIdList:[],                             //  负责人列表

      changeModalVisible:false,                       //  信息修改弹框显示
      changeConfirmLoading:false,                     //  信息修改按钮加载状态
      idChange:'',                                    //  修改用户信息id
      groupChange:'',                                 //  分组修改
      groupNewChange:'',                              //  新分组修改
      jobTitleIdChange:'',                            //  职位ID修改
      jobTitleNameChange:'',                          //  职位名称修改
      eeTypeChange:'',    
      managerEeIdChange:'',                            //  负责人ID修改
      employee_corp_change:'',                        //  员工类别修改
      employee_office_change:'',                      //  办公地点修改
      eeStatusChange:'',                              //  在职状态修改
      legalNameChange:'',                             //  姓名显示
      workdayChange:'',                               //  工作日修改
      onResignationDate:'',                           //  离职时间修改

      // 报销管理
      allInvoiceList:[],                              //  报销列表
      selectedRowKeys:[],                             //  报销/拒绝报销单号
      reasonVisible:false,                            //  拒绝原因输入框
      rejectReasonVisible:false,                      //  驳回原因输入框
      reasonContent:'',                               //  拒绝原因
      rejectReasonContent:'',                         //  驳回原因
      invoiceRefuseLoading:false,                     //  拒绝框加载
      invoiceOperateBtn:false,                        //  提交按钮状态
      invoiceExportList:[],                           //  导出列表
      invoiceStatus:1,                                //  发票类型初始状态

      // 假期管理
      workdayStatus:1,                                //  假期类型初始状态
      workdayYear:moment()                            //  今年
      .format('YYYY/MM')
      .split("/")[0], 
      workdayMonth:moment()                           //  今月
      .format('YYYY/MM')
      .split("/")[1],                                 //  获取假期月份
      leaveList:[],                                   //  休假渲染列表
      outList:[],                                     //  外出渲染列表
      allWorkdayList:[],                              //  假期列表
      allOutList:[],                                  //  外出列表

      // 硬件管理
      hardwareList:[],                                //  硬件列表
      userList:[],                                    //  所有员工列表
      searchList: [],                                 //  搜索下拉框内容
      hardwareName:'',                                //  设备持有者姓名           
      hardwareId:'',                                  //  设备持有者id        
      deviceModal:'',                                 //  设备名称 
      serialNumber:'',                             //  设备序列号
      distributionTime:'',                            //  发放日期          
      memory:'',                                //  设备序列号
      storage:'',                            //  设备表示号
      hardwareChangeStatus:false,                     //  修改框 
      hardwareChangeConfirmLoading:false,             //  确认加载状态
      hardwareNameChange:'',                          //  修改设备持有者姓名   
      handwareOnlyIdChange:'',                        //  设备id        
      hardwareIdChange:'',                            //  修改设备持有者id        
      deviceModalChange:'',                           //  修改设备名称 
      distributionTimeContentChange:'',               //  修改发放日期          
      memoryChange:'',                          //  修改设备序列号
      storageChange:'',                      //  修改设备表示号
      serialNumberChange:'',                      //  修改设备表示号
      holidayStatus:'leave',                          //  显示表格 
      tooltipWidth:{ maxWidth: '1000px' },            //  提示框样式

      defaultShowMenu:[],                              // 默认展开导航菜单

      groupNewList:[],
      allServiceStatus:[],
      serviceDate:moment()                             //  今天日期
      .format('YYYY-MM-DD')
      .slice(0, 10),
      yearValue:moment().format('YYYY'),               //  今年

      workTablevVisible:true,
      attSummaryYear:moment()                            //  今年
      .subtract(1,'month')
      .format('YYYY/MM')
      .split("/")[0],
      attSummaryMonth:moment()                           //  今月
      .subtract(1,'month')
      .format('YYYY/MM')
      .split("/")[1],
      monthLength:'',
      dateList:[],
      attendanceList:[],

      attSumExportList:[],
      attDayExportList:[],
      attSumByYearExportList:[],
    }
  },
  computed: {
    // 人员列表显示
    columns: function() {
      return this.filterUser == '2' ? workColumns : resignColumns
    },
    // 离职日期是否可选
    onResignationDateStatus:function() {
      return this.eeStatusChange == '0'
    },
    // 员工数量
    allUserInfoNum:function() {
      return this.allUserInfo.length
    },
    // 报销单数量
    allInvoiceNum:function() {
      return this.allInvoiceList.length
    },
    // 报销单导出状态
    invoiceExportStatus:function() {
      return this.invoiceExportList.length == 0
    },
    // 假期列表导出状态
    workdayExportStatus:function() {
      return this.leaveList.length == 0 || this.outList.length == 0
    },
    // 假期列表显示
    workdaycolumns:function() {
      return this.workdayStatus == 1 || this.workdayStatus == 2 || this.workdayStatus == 3 || this.workdayStatus == 4 || this.workdayStatus == 5  ? leaveColumns : outColumns
    },
    // 硬件数量
    hardwareListLength:function() {
      return this.hardwareList.length
    },
    // 年列表
    yearList:function() {
      const currentYear = new Date().getFullYear();
      return [currentYear, currentYear - 1, currentYear - 2]
    },
    
  },
  watch: {
    '$route'() {
      this.initPage()
    }
  },
  methods: {
    moment,
    //  tab 切换
    tabChangeClick(e) {
      if (e.key == 1) {
        this.$router.push({ path: '/admin/add-new-user' })
      }else if (e.key == 2) {
        this.$router.push({ path: '/admin/user-management' })
      }else if(e.key == 3) {
        this.$router.push({ path: '/admin/claim-management' })
      }else if(e.key == 4) {
        this.$router.push({ path: '/admin/workday-management' })
      }else if(e.key == 5) {
        this.$router.push({ path: '/admin/hardware-management' })
      }else if(e.key == 6) {
        // this.$router.push({ path: '/admin/service-status' })
        this.$router.push({ path: '/admin/attendance-summary' })
      }else if(e.key == 7) {
        this.$router.push({ path: '/admin/attendance-record' })
      }
    },

    // Add new User
    // 提交信息和界面重置
    resetUserAdd() {
      this.newUserContent1Visible = true
      this.newUserContent2Visible = false
      // this.newUserContent1Visible = false
      // this.newUserContent2Visible = true
    },
    // 获取新员工id
    getNewEeId() {
      this.$post(api.tool.getEeId, {
        timestamp: Date.parse(new Date()),
        token: localStorage.impr_token,
        employee_id: this.curUserId,
      }).then((res) => {
        if (res.code === 200) {
          this.eeId = res.list
        }else if(res.code === 400) {
          this.$message.error('你没有权限访问本页面，请与系统管理员联系。')
        }
      })
    },
    // 获取jobtitle
    getJobTitle() {
      this.$post(api.tool.getJobTitle, {
        timestamp: Date.parse(new Date()),
        token: localStorage.impr_token,
        employee_id: this.curUserId,
      }).then((res) => {
        if (res.code === 200) {
          this.jobTitleList = res.list
        }
      })
    },
    //  获取团队列表
    getGroupList() {
      this.$post(api.tool.getAllGroup, {
        timestamp: Date.parse(new Date()),
        token: localStorage.impr_token,
        employee_id: this.curUserId,
      }).then((res) => {
        if (res.code === 200) {
          this.groupList = res.list
          res.list.map(item => {
            let obj = {
              title: item.group_name,
              value: item.group_id,
              key: item.group_id,
            }
            treeData.push(obj)
          })
        }
      })
    },
    //  获取所有员工信息
    getAllUserInfo(){
      this.userGroupFilter = 'All'
      // this.userFliter = ['全部','在职']
      this.userStatusFilter = 'All'
      this.userTypeFilter = 'All'
      this.userTableLoading = true
      this.$post(api.tool.getAllEeInfo, {
        timestamp: Date.parse(new Date()),
        token: localStorage.impr_token,
        employee_id: this.curUserId,
      }).then((res) => {
        if (res.code === 200) {
          this.allUserInfoList = res.list
          this.allUserInfo = res.list
          // this.allUserInfoList.filter(item => {
          //   return item.ee_status == 0
          // });
          this.userTableLoading = false
        }else if(res.code === 400) {
          this.$message.error('你没有权限访问本页面，请与系统管理员联系。')
          this.userTableLoading = false
        }
      })
      this.filterUser = '2'
    },
    //  生日选择
    onDateOfBirthChange(date, dateString) {
      this.dateOfBirth = dateString
    },
    //  要过的生日选择月份
    onBirthdayMonthChange(date, dateString) {
      this.birthdayMonth = dateString
      this.birthday = `${this.birthdayMonth} ${this.birthdayDate}`
    },
    //  要过的生日选择日期
    onBirthdayDateChange(date, dateString) {
      this.birthdayDate = dateString
      this.birthday = `${this.birthdayMonth} ${this.birthdayDate}`
    },
    // 阴历 阳历
    onLunarChange(e) {
      if (e.target.checked) {
        this.birthdayLunar = '(Lunar)'
        this.birthday = `${this.birthdayMonth} ${this.birthdayDate} ${this.birthdayLunar}`
      } else {
        this.birthdayLunar = ''
        this.birthday = `${this.birthdayMonth} ${this.birthdayDate}`
      }
    },
    //  入职时间选择
    onBoardDateChange(date, dateString) {
      this.onBoardDate = dateString
    },
    //  职位选择
    onJobTitleChange(value) {
      this.jobTitleId = value.split(",")[0]
      this.jobTitleName = value.split(",")[1]
    },
    //  manage id选择
    onManageEeIdChange(value) {
      console.log(value)
      this.managerEeId = value
    },
    // ee type选择
    onEeTypeChange(value) {
      this.eeType = value
    },
    // ee type选择
    onEmployeeCorpChange(value) {
      this.employee_corp = value
    },
    // 办公地点选择
    onEmployeeOfficeChange(value) {
      this.employee_office = value
    },
    // 实习日期
    onWorkdayChange(checkedValues) {
      this.workday = checkedValues
    },
    // 分组选择
    onGroupIdChange(value) {
      this.groupId = value
    },
    // 分组选择（团队）
    onGroupNewIdChange(value) {
      this.groupNewId = value
    },
    // 第一步
    nextOne() {
      if (this.nativePlaceCity !== '') {
        this.nativePlace = `${this.nativePlaceProvince} - ${this.nativePlaceCity}`
      }
      //输入检查
      if (this.legalName == '') {
        this.$message.error('请输入Legal Name')
        return
      }else if (this.userName == '') {
        this.$message.error('请输入User Name')
        return
      }else if (this.nickName == '') {
        this.$message.error('请输入Nick Name')
        return
      }else if (this.mobileNumber == '') {
        this.$message.error('请输入Mobile Number')
        return
      }else if (this.dateOfBirth == '') {
        this.$message.error('请输入Date Of Birth')
        return
      }else if (this.birthday == '') {
        this.$message.error('请输入Birthday')
        return
      }else if (this.nativePlace == '') {
        this.$message.error('请输入Native Place')
        return
      }else if (this.emergencyContact == '') {
        this.$message.error('请输入Emergence Contact')
        return
      }
      this.newUserContent1Visible = false
      this.newUserContent2Visible = true
    },
    // 上一步
    previousStep() {
      this.newUserContent1Visible = true
      this.newUserContent2Visible = false
    },
    // 完成提交
    userSubmit() {
      //输入检查
      if (this.legalName == '') {
        this.$message.error('请输入Legal Name')
        return
      }else if (this.userName == '') {
        this.$message.error('请输入User Name')
        return
      }else if (this.nickName == '') {
        this.$message.error('请输入Nick Name')
        return
      }else if (this.mobileNumber == '') {
        this.$message.error('请输入Mobile Number')
        return
      }else if (this.dateOfBirth == '') {
        this.$message.error('请输入Date Of Birth')
        return
      }else if (this.birthday == '') {
        this.$message.error('请输入Birthday')
        return
      }else if (this.nativePlaceProvince == '' || this.nativePlaceCity == '') {
        this.$message.error('请补全Native Place')
        return
      }else if (this.emergencyContact == '') {
        this.$message.error('请输入Emergence Contact')
        return
      }else if (this.onBoardDate == '') {
        this.$message.error('请选择Onboard Date')
        return
      }else if (this.jobTitleName == 'Select Type of Job Title') {
        this.$message.error('请选择Job Title')
        return
      }else if (this.managerEeId === '') {
        this.$message.error('请选择Manage EE Id')
        return
      }else if (this.eeType === '' && this.eeType != '0') {
        this.$message.error('请选择EE Type')
        return
      }else if (this.employee_corp === ''&& this.eeType != '0') {
        this.$message.error('请选择 EE Corporate Entity')
        return
      }else if (this.employee_office === ''&& this.eeType != '0') {
        this.$message.error('请选择 EE Office')
        return
      }else if (this.eeStatus === '') {
        this.$message.error('请输入EE Status')
        return
      }else if (this.workday === '') {
        this.$message.error('请输入Workday')
        return
      }else if (this.groupNewId == '') {
        this.$message.error('请选择Reporting Group')
        return
      }else if (this.groupId.length == 0) {
        this.$message.error('请选择Work Group')
        return
      }
      //发送请求
      // console.log(this.birthday)
      // console.log(this.eeId, this.legalName, this.userName, this.nickName, this.mobileNumber, this.dateOfBirth, this.birthday, this.nativePlace, this.emergencyContact)
      // console.log(this.onBoardDate, this.jobTitleName, this.managerEeId, this.eeType, this.eeStatus, this.workday, this.groupId, this.jobTitleId)
      // this.adminUserLoading = true
      this.$post(api.tool.addEmployee, {
        timestamp: Date.parse(new Date()),
        token: localStorage.impr_token,
        employee_id: this.curUserId,
        ee_id:this.eeId,
        legal_name:this.legalName,
        username:this.userName,
        nickname:this.nickName,
        mobile_number:this.mobileNumber,
        date_of_birth:this.dateOfBirth,
        birthday:this.birthday,
        native_place:this.nativePlace,
        emergency_contact:this.emergencyContact,
        onboard_date:this.onBoardDate,
        job_title:this.jobTitleName,
        manager_ee_id:this.managerEeId,
        ee_type:this.eeType,
        employee_corp:this.employee_corp,
        employee_office:this.employee_office,
        ee_status:this.eeStatus,
        group_id:this.groupId,
        group_new_id:this.groupNewId,
        workday:this.workday,
        job_title_code:this.jobTitleId
      }).then((res) => {
        if (res.code === 200) {
          this.$message.success('信息提交成功')
          this.adminUserLoading = false
          this.newUserContent1Visible = true
          this.newUserContent2Visible = false
          this.resetUserInfo()
        }else {
          this.adminUserLoading = false
          this.$message.error('信息提交失败')
        }
      })
    },
    // 输入信息重置
    resetUserInfo() {
      this.getNewEeId()
      this.legalName = ''
      this.userName = ''
      this.nickName = ''
      this.mobileNumber = ''
      this.dateOfBirth = ''
      this.birthday = ''
      this.nativePlace = ''
      this.nativePlaceProvince = ''
      this.nativeCity = ''
      this.emergencyContact = ''
      this.onBoardDate = ''
      this.jobTitleName = 'Select Type of Job Title'
      this.managerEeId = ''
      this.eeType = ''
      this.employee_corp = ''
      this.employee_office = ''
      this.eeStatus = '0'
      this.workday = ''
      this.groupId = []
      this.groupNewId = ''
      this.jobTitleId = ''
    },

    // 获取团队结构列表
    getteamStructureList(){
      this.$post(api.tool.getAllGroupNew, {
        timestamp: Date.parse(new Date()),
        token: localStorage.impr_token,
        employee_id: this.curUserId,
      }) .then((res) => {
        if(res.code == 200) {
          let tempArr = res.list
          tempArr.shift()
          this.groupNewList = tempArr
        }
      })
    },


    // User Management
    // 人员过滤筛选
    onUserStatusChange(e) {
      const checkedValues = e.target.value
      console.log(checkedValues)
      this.userStatusFilter = checkedValues
      this.onAllUserChange()
    },  
    onUserTypeChange(e) {
      const checkedValues = e.target.value
      console.log(checkedValues)
      this.userTypeFilter = checkedValues
      this.onAllUserChange()
    },
    onAllUserGroupChange(e) {
      const checkedValues = e.target.value
      console.log(checkedValues)
      this.userGroupFilter = checkedValues
      this.onAllUserChange()
    },
    onAllUserChange(){
      this.allUserInfo = this.allUserInfoList.filter(item => {
        let status = this.userStatusFilter == 'All' ? true : item.ee_status == this.userStatusFilter
        let type = this.userTypeFilter == 'All' ? true : item.ee_type == this.userTypeFilter
        let group = this.userGroupFilter == 'All' ? true : item.group_new[0]&&item.group_new[0].group_id&&item.group_new[0].group_id == this.userGroupFilter
        return group&&status&&type;
      })
    },
    // 修改信息
    userInfoChange(item) {
      console.log(item)
      this.changeModalVisible = true;
      var groupArr = []
      item.group.map(item => {
        groupArr.push(item.group_id)
      })
      var WorkdayArr =  item.workday.split(',')
      this.idChange = item.employee_id
      this.groupChange = groupArr
      this.groupNewChange = item.group_new.length == 0 ? '' : item.group_new[0].group_id
      this.jobTitleIdChange = item.job_title_code
      this.jobTitleNameChange = item.job_title
      this.eeTypeChange = item.ee_type 
      this.managerEeIdChange = item.manager_ee_id
      this.employee_corp_change= item.employee_corp
      this.employee_office_change = item.employee_office
      this.eeStatusChange = item.ee_status 
      this.legalNameChange = item.legal_name
      this.workdayChange = WorkdayArr.sort()
      this.onResignationDate = item.resignation_date
    },
    groupInfoChange(checkedValues) {
      this.groupChange = checkedValues
    },
    groupNewInfoChange(id) {
        // console.log(id.target.value)
      this.groupNewChange = id.target.value
    },
    jobTitleInfoChange(value) {
      this.jobTitleIdChange = value.split(",")[0]
      this.jobTitleNameChange = value.split(",")[1]
    },
    eeTypeInfoChange(value) {
      this.eeTypeChange = value
    },
    managerEeIdInfoChange(value) {
      this.managerEeIdChange = value
    },
    employeeCorpInfoChange(value) {
      this.employee_corp_change = value
    },
    employeeOfficeChange(value) {
      this.employee_office_change = value
    },
    eeStatusInfoChange(value) {
      this.eeStatusChange = value
      if(value == '0') {
        this.onResignationDate = null
      }
    },
    workdayInfoChange(checkedValues) {
      this.workdayChange = checkedValues.sort()
    },
    onResignationDateChange(date, dateString) {
      this.onResignationDate = dateString
    },
    // 修改提交
    infoChangeOk() {
      // console.log(this.curUserId,this.idChange,this.groupChange,this.jobTitleIdChange,this.jobTitleNameChange,this.eeTypeChange,this.eeStatusChange,this.workdayChange)
      this.changeConfirmLoading = true;
      // 发送请求
      this.$post(api.tool.editEmployee, {
        timestamp: Date.parse(new Date()),
        token: localStorage.impr_token,
        employee_id: this.curUserId,
        group_id:this.groupChange,
        group_new_id: this.groupNewChange,
        job_title:this.jobTitleNameChange,
        job_title_code:this.jobTitleIdChange,
        ee_type:this.eeTypeChange,
        manager_ee_id:this.managerEeIdChange,
        employee_corp:this.employee_corp_change,
        employee_office:this.employee_office_change,
        ee_status:this.eeStatusChange,
        workday:this.workdayChange,
        ee_id:this.idChange,
        resignation_date:this.onResignationDate
      }).then((res) => {
        if (res.code === 200) {
          this.changeModalVisible = false;
          this.changeConfirmLoading = false;
          this.$message.success('信息修改成功')
          this.getAllUserInfo()
        }else {
          this.$message.error('信息修改失败')
          this.changeConfirmLoading = false;
        }
      })
    },
    // 修改取消
    infoChangeCancel() {
      this.changeModalVisible = false;
      this.$message.warning('信息修改取消')
    },


    // Claim Management
    // 获取报销列表
    getAllInvoice(status) {
      this.invoiceStatus = status
      this.claimTableLoading = true
      this.$post(api.tool.getAllRbList, {
        timestamp: Date.parse(new Date()),
        token: localStorage.impr_token,
        employee_id: this.curUserId,
        rb_status:status,
        year:this.yearValue
      }).then((res) => {
        if (res.code === 200) {
          this.allInvoiceList = res.list
          this.allInvoiceList.forEach(item => {
            let sumList = parseFloat(item.sum).toFixed(2).split('.')
            item.sum = sumList[0].replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') + '.' + sumList[1]
          })
          this.selectedRowKeys = []
          this.invoiceExportList = []
          this.reasonContent = ''
          this.rejectReasonContent = ''
          this.invoiceOperateBtn = true
          this.claimTableLoading = false
          this.reasonVisible = false
        }else if(res.code === 400) {
          this.$message.error('你没有权限访问本页面，请与系统管理员联系。')
        }
      })
    },
    // 全选
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.invoiceExportList = selectedRows
      // console.log(selectedRows)
      if(this.selectedRowKeys.length != 0) {
        this.invoiceOperateBtn = false
      } else {
        this.invoiceOperateBtn = true
      }
      if(this.reasonVisible == true) {
        this.reasonVisible = false
        this.reasonContent = ''
      }
      if(this.rejectReasonVisible == true) {
        this.rejectReasonVisible = false
        this.rejectReasonContent = ''
      }
    },
    // 每行点击事件
    Rowclick(record) {
      return {
        on: {
          click:() => {
            if(this.selectedRowKeys.includes(record.rb_number)) {
              var eleIndex = this.selectedRowKeys.findIndex(item => {
                return item == record.rb_number
              })
              this.selectedRowKeys.splice(eleIndex, 1)
              this.invoiceExportList.splice(eleIndex,1)
            }else {
              this.selectedRowKeys.push(record.rb_number)
              this.invoiceExportList.push(record)
            }
            if(this.selectedRowKeys.length != 0) {
              this.invoiceOperateBtn = false
            } else {
              this.invoiceOperateBtn = true
            }
            if(this.reasonVisible == true) {
              this.reasonVisible = false
              this.reasonContent = ''
            }
            if(this.rejectReasonVisible == true) {
              this.rejectReasonVisible = false
              this.rejectReasonContent = ''
            }
          }
        }
      }
    },
    // 通过报销确认/拒绝报销确认
    invoiceStatusChangeConfirm(status) {
      // console.log(this.selectedRowKeys)
      if(this.selectedRowKeys.length == 0) {
        this.$message.error('请选择报销单')
        return
      }
      var reasons
      if(status == 3) {
        reasons = this.reasonContent
      }else if(status == 5) {
        reasons = this.rejectReasonContent
      }
      this.claimTableLoading = true
      // 发送请求
      this.$post(api.tool.updateRbStatus, {
        timestamp: Date.parse(new Date()),
        token: localStorage.impr_token,
        employee_id: this.curUserId,
        rb_number:this.selectedRowKeys,
        reasons:reasons,
        rb_status:status
      }).then((res) => {
        if (res.code === 200) {
          this.$message.success('提交成功')
          if(status == 2 || status == 3 || status == 5) {
            this.$message.success('邮件发送成功')
          }
          this.getAllInvoice(status)
        }
      })
    },
    // 显示拒绝理由弹框
    invoiceRefuse() {
      this.reasonVisible = true
      this.invoiceOperateBtn = true
    },
    // 显示驳回理由弹框
    invoiceReject() {
      this.rejectReasonVisible = true
      this.invoiceOperateBtn = true
    },
    // 取消操作
    invoiceOperateCancel() {
      this.$message.warning('操作已取消')
    },
    // 导出InvoiceExcel
    invoiceExport2Excel() {
      require.ensure([], () => {
        const { export_json_to_excel } = require('../../excel/Export2Excel');//路径需要自行修改
        let tHeader = ['报销序号','报销类型','类型编码','报销单名称','申请人','金额'];
        let filterVal = ['rb_number', 'category_name','category_code','rb_name','legal_name','sum'];
        let tTitle = '报销单汇总 - ' + this.todayDate
        //把data里的tableData存到list
        const list = this.invoiceExportList
        const data = this.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, tTitle);
      })
    },
    // 数据格式转换
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },
    // 发票类型修改
    invoiceStatusChange(e) {
      this.rejectReasonVisible = false
      this.reasonVisible = false
      // 重新获取发票列表
      this.getAllInvoice(e.target.value)

    },

    // Workday Management
    // 获取假期列表
    getAllWorkday() {
      this.workdayTableLoading = true
      this.$post(api.tool.leaveManage, {
        timestamp: Date.parse(new Date()),
        token: localStorage.impr_token,
        employee_id: this.curUserId,
        month:this.workdayMonth,
        year:this.workdayYear
      }).then((res) => {
        if (res.code === 200) {
          this.workdayStatus = 1
          this.allWorkdayList = res.list
          this.leaveList = this.allWorkdayList
          this.workdayTableLoading = false
        }
      })
    },
    // 获取外出列表
    getAllOut() {
      this.workdayTableLoading = true
      this.$post(api.tool.outManage, {
        timestamp: Date.parse(new Date()),
        token: localStorage.impr_token,
        employee_id: this.curUserId,
        month:this.workdayMonth,
        year:this.workdayYear
      }).then((res) => {
        if (res.code === 200) {
          this.allOutList = res.list
          this.outList = this.allOutList
          if (this.workdayStatus == 5) {
            this.outList = this.allOutList
          }else if (this.workdayStatus == 6) {
            this.outList = this.allOutList.filter(item => {
              return item.out_cat_code == 400
            })
          }else if (this.workdayStatus == 7) {
            this.outList = this.allOutList.filter(item => {
              return item.out_cat_code == 500
            })
          }
          this.workdayTableLoading = false
        }
      })
    },
    // 假期月份请求
    workdayMonthChange(date,dateString){
      this.workdayMonth = dateString.split('/')[1]
      this.workdayYear = dateString.split('/')[0]
      // 重新请求
      this.getAllWorkday()
      this.getAllOut()
    },
    // 假期类型过滤筛选
    workdayStatusChange(e) {
      if(e.target.value == 1) {
        this.holidayStatus = 'leave'
        this.leaveList = this.allWorkdayList
      }else if (e.target.value == 2) {
        this.holidayStatus = 'leave'
        this.leaveList = this.allWorkdayList.filter(item => {
          return item.leave_cat_code == 100
        })
      }else if (e.target.value == 3) {
        this.holidayStatus = 'leave'
        this.leaveList = this.allWorkdayList.filter(item => {
          return item.leave_cat_code == 200
        })
      }else if (e.target.value == 4) {
        this.holidayStatus = 'leave'
        this.leaveList = this.allWorkdayList.filter(item => {
          return item.leave_cat_code == 300
        })
      }else if (e.target.value == 5) {
        this.holidayStatus = 'leave'
        this.leaveList = this.allWorkdayList.filter(item => {
          return item.leave_cat_code == 400
        })
      }else if (e.target.value == 6) {
        this.holidayStatus = 'out'
        this.outList = this.allOutList
      }else if (e.target.value == 7) {
        this.holidayStatus = 'out'
        this.outList = this.allOutList.filter(item => {
          return item.out_cat_code == 400
        })
      }else if (e.target.value == 8) {
        this.holidayStatus = 'out'
        this.outList = this.allOutList.filter(item => {
          return item.out_cat_code == 500
        })
      }else if (e.target.value == 9) {
        this.holidayStatus = 'out'
        this.outList = this.allOutList.filter(item => {
          return item.out_cat_code == 600
        })
      }
    },
    // 导出WorkdayExcel
    workdayExport2Excel() {
      require.ensure([], () => {
        const { export_json_to_excel } = require('../../excel/Export2Excel');//路径需要自行修改
        if(this.workdayStatus == 1 || this.workdayStatus == 2 || this.workdayStatus == 3 || this.workdayStatus == 4) {
          let tHeader = ['Id','Name','Type of Leave/Out','StartDate','EndDate','Days'];
          let filterVal = ['id', 'legal_name','leave_cat_name_chn','leave_startdate','leave_enddate','leave_days'];
          let tTitle = '请假汇总 - ' + this.todayDate
          //把data里的tableData存到list
          const list = this.leaveList
          const data = this.formatJson(filterVal, list);
          export_json_to_excel(tHeader, data, tTitle);
        }else {
          let tHeader = ['Id','Name','Type of Leave/Out','StartDate','EndDate','Days','Participants'];
          let filterVal = ['id', 'legal_name','out_cat_name_chn','out_startdate','out_enddate','out_days','participants'];
          let tTitle = '请假汇总 - ' + this.todayDate
          //把data里的tableData存到list
          const list = this.outList
          const data = this.formatJson(filterVal, list);
          export_json_to_excel(tHeader, data, tTitle);
        }
        
      })
    },

    // Hardware Management
    // 获取设备信息
    getAllHardwareList() {
      this.hardwareTableLoading = true
      this.$post(api.tool.allHardware, {
        timestamp: Date.parse(new Date()),
        token: localStorage.impr_token,
        employee_id: this.curUserId,
      }).then((res) => {
        if (res.code === 200) {
          this.hardwareList = res.list
          this.hardwareTableLoading = false
        }
      })
      this.handwareOnlyIdChange = ''
      this.hardwareId = ''
      this.hardwareName = ''
      this.deviceModal = ''
      this.distributionTime = '',
      this.memory = '',
      this.storage='',
      this.serialNumber=''
    },
    //  获取所有员工
    getUserList() {
      this.$post(api.tool.getUserList, {
        timestamp: Date.parse(new Date()),
        token: localStorage.impr_token,
        employee_id: this.curUserId,
      }).then((res) => {
        if (res.code === 200) {
          this.userList = res.list
        }
      })
    },
    // 选择员工
    onNameChange(name) {
      if (name == '') {
        this.searchList = []
      } else {
        this.searchList = this.userList.filter(item => {
          return item.username.indexOf(name.toLowerCase()) != -1 || item.legal_name.indexOf(name) != -1
        })
      }
    },
    // 选择后查询更改查询id 发起请求
    onNameSelect(info) {
      this.hardwareId = info.split(',')[0]
      this.hardwareName = info.split(',')[1]
      //  发起请求
    },
    // 日期
    distributionTimeChange(data,dataString) {
      this.distributionTime = dataString
    },
    // 设备提交
    diviceSubmit(){
      // 发送请求
      this.$post(api.tool.dealHardware, {
        timestamp: Date.parse(new Date()),
        token: localStorage.impr_token,
        employee_id: this.curUserId,
        ee_id:this.hardwareId,
        distribution_time:this.distributionTime,
        device_model:this.deviceModal,
        memory:this.memory,
        storage:this.storage,
        serial_number:this.serialNumber,
        id:this.handwareOnlyIdChange
      }).then((res) => {
        if (res.code === 200) {
          this.getAllHardwareList()
          this.$message.success('添加成功')
        }
      })

    },
    // 设备修改
    userHandwareChange(user){
      this.hardwareChangeStatus = true
      this.handwareOnlyIdChange = user.id
      this.hardwareIdChange = user.employee_id
      this.hardwareNameChange = user.legal_name
      this.deviceModalChange = user.device_model
      this.distributionTimeContentChange = user.distribution_time
      this.memoryChange = user.memory
      this.storageChange = user.storage
      this.serialNumberChange = user.serial_number
    },
    //  选择后查询更改查询id 发起请求
    onChangeNameSelect(info) {
      this.hardwareIdChange = info.split(',')[0]
      this.hardwareNameChange = info.split(',')[1]
    },
    // 时间修改
    distributionTimeUpdate(data,dataString) {
      this.distributionTimeContentChange = dataString
    },
    // 确认修改
    hardwareChangeOk(){
      this.hardwareChangeConfirmLoading = true
      // console.log(
      //   'id:' + this.handwareOnlyIdChange,
      //   '设备持有人id:' + this.hardwareIdChange,
      //   '设备名称:' + this.deviceModalChange,
      //   '发放日期:' + this.distributionTimeContentChange,
      //   '设备序列号:' + this.memoryChange,
      //   '设备标识号:' + this.storageChange
      // )
      this.$post(api.tool.dealHardware, {
        timestamp: Date.parse(new Date()),
        token: localStorage.impr_token,
        employee_id: this.curUserId,
        ee_id:this.hardwareIdChange,
        distribution_time:this.distributionTimeContentChange,
        device_model:this.deviceModalChange,
        memory:this.memoryChange,
        storage:this.storageChange,
        serial_number:this.serialNumberChange,
        id:this.handwareOnlyIdChange
      }).then((res) => {
        if (res.code === 200) {
          this.hardwareChangeStatus = false
          this.getAllHardwareList()
          this.hardwareChangeConfirmLoading = false
          this.$message.success('修改成功')
        }
      })
    },
    // 取消修改
    hardwareChangeCancel(){
      this.hardwareChangeStatus = false
    },
    // 设备删除
    userHandwareDelete(id){
      this.$post(api.tool.deleteHardware, {
        timestamp: Date.parse(new Date()),
        token: localStorage.impr_token,
        employee_id: this.curUserId,
        id: id,
      }).then((res) => {
        if (res.code === 200) {
          this.getAllHardwareList()
          this.$message.success('删除成功')
        }
      })
    },
    // 设备回收
    userHandwareRetrieve(user){
      this.$post(api.tool.retrieveHardware, {
        timestamp: Date.parse(new Date()),
        token: localStorage.impr_token,
        employee_id: this.curUserId,
        id: user.id
      }).then((res) => {
        if (res.code === 200) {
          this.getAllHardwareList()
          this.$message.success('修改成功')
        }
      })
    },
    // 外出假期删除
    outDelete(id) {
      this.$post(api.tool.outDelete, {
        timestamp: Date.parse(new Date()),
        token: localStorage.impr_token,
        employee_id: this.curUserId,
        id:id,
      }).then((res) => {
        if (res.code === 200) {
          this.getAllOut()
          this.$message.success('删除成功')
        }
      })
    },
    onDateChange(date) {
      this.serviceDate = date.format('YYYY-MM-DD')
      this.getServerStatus()
    },
    getServerStatus() {
      this.serviceStatusLoading = true
      this.$post(api.tool.getServerStatus, {
        timestamp: Date.parse(new Date()),
        token: localStorage.impr_token,
        employee_id: this.curUserId,
        ping_date:this.serviceDate
      }).then((res) => {
        if (res.code === 200) {
          this.allServiceStatus = res.list.reverse()
          let list = res.list

          //  添加筛选内容
          // 站点
          let columns0Filter = []
          list.forEach(item => {
            let index = columns0Filter.findIndex(a => a.text == item.domain)
            if (index === -1) {
              columns0Filter.push({
                text: item.domain,
                value: item.domain,
              })
            }
          })
          serviceStatusColumns[0].filters = columns0Filter
          // 组
          let columns1Filter = []
          list.forEach(item => {
            let index = columns1Filter.findIndex(a => a.text == item.groups)
            if (index === -1) {
              columns1Filter.push({
                text: item.groups,
                value: item.groups,
              })
            }
          })
          serviceStatusColumns[1].filters = columns1Filter



          // 时间
          let columns4Filter = []
          list.forEach(item => {
            let index = columns4Filter.findIndex(a => a.text == item.ping_hour)
            if (index === -1) {
              columns4Filter.push({
                text: item.ping_hour,
                value: item.ping_hour,
              })
            }
          })
          serviceStatusColumns[4].filters = columns4Filter
          this.serviceStatusLoading = false

        }
      })
    },

    attSumMonthChange(date,dateString){
      this.attSummaryMonth = dateString.split('/')[1]
      this.attSummaryYear = dateString.split('/')[0]
      this.monthPreviewDate = this.attSummaryYear + '-' +  this.attSummaryMonth
      // 重新请求
      this.getAttSummary()
      this.getAttendanceSummaryByYear()
    },
    attDayMonthChange(date,dateString){
      // console.log(moment(tempDay,'YYYY-MM').daysInMonth())
      this.attSummaryMonth = dateString.split('/')[1]
      this.attSummaryYear = dateString.split('/')[0]
      this.monthPreviewDate = this.attSummaryYear + '-' +  this.attSummaryMonth
      this.getAttRecord()
    },
    getAttSummary() {
      this.attSumTableLoading = true
      this.$post(api.tool.getAttendanceSummary, {
        timestamp: Date.parse(new Date()),
        token: localStorage.impr_token,
        employee_id: this.curUserId,
        year:this.attSummaryYear,
        month:this.attSummaryMonth,
      }).then((res) => {
        if (res.code === 200) {
          this.attSumList = res.list
          this.attSumExportList = res.list
          this.attSumTableLoading = false
        }
      })
    },
    getAttendanceSummaryByYear() {
      this.$post(api.tool.getAttendanceSummaryByYear, {
        timestamp: Date.parse(new Date()),
        token: localStorage.impr_token,
        employee_id: this.curUserId,
        year:this.attSummaryYear,
      }).then((res) => {
        if (res.code === 200) {
          this.attSumByYearExportList = res.list
        }
      })
    },
    getAttRecord() {
      this.attDayTableLoading = true
      this.attDayColumns =  [
        {
          title: '姓名',
          dataIndex: 'legal_name',
          align: 'center',
          width:100,
          fixed: true,
        },
        {
          title: 'FTE/Intern',
          dataIndex: 'ee_type',
          align: 'center',
          width:100,
          scopedSlots: { customRender: 'ee_type' },
        },
      ]

      this.$post(api.tool.getAttendanceRecord, {
        timestamp: Date.parse(new Date()),
        token: localStorage.impr_token,
        employee_id: this.curUserId,
        month:this.attSummaryMonth,
        year:this.attSummaryYear,
      }).then((res) => {
        if (res.code === 200) {
          this.monthLength = res.list.date_list.length

          for(let i = 0;i < this.monthLength;i++) {
            this.attDayColumns.push({
              title:res.list.date_list[i],
              dataIndex: res.list.date_list[i],
              align: 'center',
              width:160,
              scopedSlots: { customRender: res.list.date_list[i] },
            })
          }

          this.dateList = res.list.date_list
          this.attDayList = res.list.attendance_list
          this.attDayExportList = res.list.attendance_list
          this.attDayTableLoading = false

        }
      })
    },
    attSummaryExport2Excel() {
      this.attSumExportList.map((item,index) => {
        let eeValue = ''
        if(item.ee_type == 0) {
          eeValue = 'FTE'
        }else if(item.ee_type == 1) {
          eeValue = 'Intern'
        }
        let percentValue = isNaN(((item.normal / (item.work_days - item.business - item.annual_days) * 100 ).toFixed(0) )) ? '-' : ((item.normal / (item.work_days - item.business - item.annual_days) * 100).toFixed(0) ) + '%'
        let correctPercentValue = isNaN(((item.normal / item.must_attendance) * 100).toFixed(2)) ? '-' : ((item.normal / item.must_attendance) * 100).toFixed(0) + '%'
        let lessValue = item.less_on + item.less_out
        let absentValue = item.business + item.leave
        let dayAvg = isNaN(((item.hour / (item.normal + item.late + item.early )).toFixed(1))) ? '-' : ((item.hour / (item.normal + item.late + item.early )).toFixed(1))
        this.attSumExportList[index].ee_value = eeValue
        this.attSumExportList[index].percent = percentValue
        this.attSumExportList[index].correct = correctPercentValue
        this.attSumExportList[index].less = lessValue
        this.attSumExportList[index].absent = absentValue
        this.attSumExportList[index].daily = dayAvg
      })
      require.ensure([], () => {
        const { export_json_to_excel } = require('../../excel/Export2Excel');//路径需要自行修改
        let tHeader = ['姓名','月份','正常','迟到','早退','缺卡','外出','团建','WFH','病假','年假','其他假','打卡总时长（分钟）','日平均工时'];
        let filterVal = ['legal_name','month','normal','late','early','less','out','teambuilding','wfh','sick_days','annual_days','other_days','duration','daily'];
        // let tHeader = ['姓名','月份','FTE/Intern','出勤率','正常打卡率','工作日','出勤','正常','迟到','早退','缺卡','未出勤','a.因公不在','a1.外出','a2.团建','a3.WFH','b.因私不在','b1.病假','b2.年假','b3.其他假','打卡总时长（分钟）','日平均工时'];
        // let filterVal = ['legal_name','month','ee_value','percent','correct','work_days','must_attendance','normal','late','early','less','absent','business','out','teambuilding','wfh','leave','sick_days','annual_days','other_days','duration','daily'];
        let tTitle = '考勤汇总' + this.monthPreviewDate
        //把data里的tableData存到list
        const list = this.attSumExportList
        const data = this.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, tTitle);
      })
    },
    attSummaryByYearExport2Excel() {
      this.attSumByYearExportList.map((item,index) => {
        let eeValue = ''
        if(item.ee_type == 0) {
          eeValue = 'FTE'
        }else if(item.ee_type == 1) {
          eeValue = 'Intern'
        }
        let percentValue = isNaN(((item.normal / (item.work_days - item.business - item.annual_days) * 100 ).toFixed(0) )) ? '-' : ((item.normal / (item.work_days - item.business - item.annual_days) * 100).toFixed(0) ) + '%'
        let correctPercentValue = isNaN(((item.normal / item.must_attendance) * 100).toFixed(2)) ? '-' : ((item.normal / item.must_attendance) * 100).toFixed(0) + '%'
        let lessValue = item.less_on + item.less_out
        let absentValue = item.business + item.leave
        let dayAvg = isNaN(((item.hour / (item.normal + item.late + item.early )).toFixed(1))) ? '-' : ((item.hour / (item.normal + item.late + item.early )).toFixed(1))
        this.attSumByYearExportList[index].ee_value = eeValue
        this.attSumByYearExportList[index].percent = percentValue
        this.attSumByYearExportList[index].correct = correctPercentValue
        this.attSumByYearExportList[index].less = lessValue
        this.attSumByYearExportList[index].absent = absentValue
        this.attSumByYearExportList[index].daily = dayAvg
      })
      require.ensure([], () => {
        const { export_json_to_excel } = require('../../excel/Export2Excel');//路径需要自行修改
        let tHeader = ['姓名','月份','正常','迟到','早退','缺卡','外出','团建','WFH','病假','年假','其他假','打卡总时长（分钟）','日平均工时'];
        let filterVal = ['legal_name','month','normal','late','early','less','out','teambuilding','wfh','sick_days','annual_days','other_days','duration','daily'];
        // let tHeader = ['姓名','月份','FTE/Intern','出勤率','正常打卡率','工作日','出勤','正常','迟到','早退','缺卡','未出勤','a.因公不在','a1.外出','a2.团建','a3.WFH','b.因私不在','b1.病假','b2.年假','b3.其他假','打卡总时长（分钟）','日平均工时'];
        // let filterVal = ['legal_name','month','ee_value','percent','correct','work_days','must_attendance','normal','late','early','less','absent','business','out','teambuilding','wfh','leave','sick_days','annual_days','other_days','duration','daily'];
        let tTitle = '考勤汇总 ' + this.attSummaryYear
        //把data里的tableData存到list
        const list = this.attSumByYearExportList
        const data = this.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, tTitle);
      })
    },

    attRecordExport2Excel() {
      let tHeader = ['姓名','FTE/Intern'];
      let filterVal = ['legal_name','ee_type'];

      this.dateList.map(item => {
        tHeader.push(item)
        filterVal.push(item)
      })

      this.attDayList.map((item,index) => {
        this.dateList.map(day => {
          item.attendance.map(att => {
            if(att.work_date.includes(day) && !att.check_time_on.includes(day)) {
              this.attDayExportList[index][day] = att.status_msg +
              (att.check_time_on === '-' && att.check_time_off === '-' ? '' : '（' + att.check_time_on.slice(0,5) + ','+ att.check_time_off.slice(0,5) + '）')
            }
          })
        })
      })

      require.ensure([], () => {
        const { export_json_to_excel } = require('../../excel/Export2Excel');//路径需要自行修改
        let tTitle = '考勤每日打卡记录' + this.monthPreviewDate
        //把data里的tableData存到list
        const list = this.attDayExportList
        const data = this.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, tTitle);
      })
    },
    // 获取负责人列表
    getManageList() {
      this.$post(api.tool.getManageList, {
        timestamp: Date.parse(new Date()),
        token: localStorage.impr_token,
        employee_id: this.curUserId,
      }).then((res) => {
        if (res.code === 200) {
          
          this.manageList = res.list
        }
      })
    },

    yearChange() {
      this.getAllInvoice(1)
      this.$post(api.tool.getAllBalance, {
        timestamp: Date.parse(new Date()),
        token: localStorage.impr_token,
        employee_id: this.curUserId,
        year:this.yearValue,
      }).then((res) => {
        if (res.code === 200) {
          this.workdayList = res.list
        }
      })
    },

    // 路由 - 初始化页面
    initPage() {
      if(this.$route.params.category == undefined || this.$route.params.category == 'add-new-user') {
        this.$nextTick(() => {
          this.$refs.newIcon.style.display = 'none'
          this.$refs.newIconBlue.style.display = 'initial'
          this.$refs.historyIcon.style.display = 'initial'
          this.$refs.historyIconBlue.style.display = 'none'
          this.$refs.claimIcon.style.display = 'initial'
          this.$refs.claimIconBlue.style.display = 'none'
          this.$refs.workdayIcon.style.display = 'initial'
          this.$refs.workdayIconBlue.style.display = 'none'
          this.$refs.hardwareIcon.style.display = 'initial'
          this.$refs.hardwareIconBlue.style.display = 'none'
          this.$refs.atteSummaryIcon.style.display = 'initial'
          this.$refs.atteSummaryIconBlue.style.display = 'none'
          this.$refs.atteRecordIcon.style.display = 'initial'
          this.$refs.atteRecordIconBlue.style.display = 'none'
        })
        this.adminUserVisible = true
        this.adminStatusVisible = false
        this.adminClaimVisible = false
        this.adminWorkdayVisible = false
        this.adminHardwareVisible = false
        this.adminServiceVisible = false
        this.adminAttSumVisible = false
        this.adminAttDayVisible = false
        this.resetUserAdd()
        this.defaultShowMenu = ['1']
      }else if(this.$route.params.category == 'user-management') {
        this.$nextTick(() => {
          this.$refs.newIcon.style.display = 'initial'
          this.$refs.newIconBlue.style.display = 'none'
          this.$refs.historyIcon.style.display = 'none'
          this.$refs.historyIconBlue.style.display = 'initial'
          this.$refs.claimIcon.style.display = 'initial'
          this.$refs.claimIconBlue.style.display = 'none'
          this.$refs.workdayIcon.style.display = 'initial'
          this.$refs.workdayIconBlue.style.display = 'none'
          this.$refs.hardwareIcon.style.display = 'initial'
          this.$refs.hardwareIconBlue.style.display = 'none'
          this.$refs.atteSummaryIcon.style.display = 'initial'
          this.$refs.atteSummaryIconBlue.style.display = 'none'
          this.$refs.atteRecordIcon.style.display = 'initial'
          this.$refs.atteRecordIconBlue.style.display = 'none'

        })
        this.adminUserVisible = false
        this.adminStatusVisible = true
        this.adminClaimVisible = false
        this.adminWorkdayVisible = false
        this.adminHardwareVisible = false
        this.adminServiceVisible = false
        this.adminAttSumVisible = false
        this.adminAttDayVisible = false
        this.getAllUserInfo()
        this.defaultShowMenu = ['2']
      }else if (this.$route.params.category == 'claim-management') {
        this.$nextTick(() => {
          this.$refs.newIcon.style.display = 'initial'
          this.$refs.newIconBlue.style.display = 'none'
          this.$refs.historyIcon.style.display = 'initial'
          this.$refs.historyIconBlue.style.display = 'none'
          this.$refs.claimIcon.style.display = 'none'
          this.$refs.claimIconBlue.style.display = 'initial'
          this.$refs.workdayIcon.style.display = 'initial'
          this.$refs.workdayIconBlue.style.display = 'none'
          this.$refs.hardwareIcon.style.display = 'initial'
          this.$refs.hardwareIconBlue.style.display = 'none'
          this.$refs.atteSummaryIcon.style.display = 'initial'
          this.$refs.atteSummaryIconBlue.style.display = 'none'
          this.$refs.atteRecordIcon.style.display = 'initial'
          this.$refs.atteRecordIconBlue.style.display = 'none'
        })
        
        this.adminUserVisible = false
        this.adminStatusVisible = false
        this.adminClaimVisible = true
        this.adminWorkdayVisible = false
        this.adminHardwareVisible = false
        this.adminServiceVisible = false
        this.adminAttSumVisible = false
        this.adminAttDayVisible = false
        this.getAllInvoice(1)
        this.defaultShowMenu = ['3']
      }else if(this.$route.params.category == 'workday-management') {
        this.$nextTick(() => {
          this.$refs.newIcon.style.display = 'initial'
          this.$refs.newIconBlue.style.display = 'none'
          this.$refs.historyIcon.style.display = 'initial'
          this.$refs.historyIconBlue.style.display = 'none'
          this.$refs.claimIcon.style.display = 'initial'
          this.$refs.claimIconBlue.style.display = 'none'
          this.$refs.workdayIcon.style.display = 'none'
          this.$refs.workdayIconBlue.style.display = 'initial'
          this.$refs.hardwareIcon.style.display = 'initial'
          this.$refs.hardwareIconBlue.style.display = 'none'
          this.$refs.atteSummaryIcon.style.display = 'initial'
          this.$refs.atteSummaryIconBlue.style.display = 'none'
          this.$refs.atteRecordIcon.style.display = 'initial'
          this.$refs.atteRecordIconBlue.style.display = 'none'
        })
        this.adminUserVisible = false
        this.adminStatusVisible = false
        this.adminClaimVisible = false
        this.adminWorkdayVisible = true
        this.adminHardwareVisible = false
        this.adminServiceVisible = false
        this.adminAttSumVisible = false
        this.adminAttDayVisible = false
        this.workdayStatus = 1
        this.holidayStatus = 'leave'
        this.getAllWorkday()
        this.getAllOut()
        this.defaultShowMenu = ['4']
      }else if(this.$route.params.category == 'hardware-management') {
        this.$nextTick(() => {
          this.$refs.newIcon.style.display = 'initial'
          this.$refs.newIconBlue.style.display = 'none'
          this.$refs.historyIcon.style.display = 'initial'
          this.$refs.historyIconBlue.style.display = 'none'
          this.$refs.claimIcon.style.display = 'initial'
          this.$refs.claimIconBlue.style.display = 'none'
          this.$refs.workdayIcon.style.display = 'initial'
          this.$refs.workdayIconBlue.style.display = 'none'
          this.$refs.hardwareIcon.style.display = 'none'
          this.$refs.hardwareIconBlue.style.display = 'initial'
          this.$refs.atteSummaryIcon.style.display = 'initial'
          this.$refs.atteSummaryIconBlue.style.display = 'none'
          this.$refs.atteRecordIcon.style.display = 'initial'
          this.$refs.atteRecordIconBlue.style.display = 'none'
        })
        this.adminUserVisible = false
        this.adminStatusVisible = false
        this.adminClaimVisible = false
        this.adminWorkdayVisible = false
        this.adminHardwareVisible = true
        this.adminServiceVisible = false
        this.adminAttSumVisible = false
        this.adminAttDayVisible = false
        this.getUserList()
        this.getAllHardwareList()
        this.defaultShowMenu = ['5']
      }
      // else if(this.$route.params.category == 'service-status') {
      //   this.$nextTick(() => {
      //     this.$refs.newIcon.style.display = 'initial'
      //     this.$refs.newIconBlue.style.display = 'none'
      //     this.$refs.historyIcon.style.display = 'initial'
      //     this.$refs.historyIconBlue.style.display = 'none'
      //     this.$refs.claimIcon.style.display = 'initial'
      //     this.$refs.claimIconBlue.style.display = 'none'
      //     this.$refs.workdayIcon.style.display = 'initial'
      //     this.$refs.workdayIconBlue.style.display = 'none'
      //     this.$refs.hardwareIcon.style.display = 'initial'
      //     this.$refs.hardwareIconBlue.style.display = 'none'
      //   })
      //   this.adminUserVisible = false
      //   this.adminStatusVisible = false
      //   this.adminClaimVisible = false
      //   this.adminWorkdayVisible = false
      //   this.adminHardwareVisible = false
      //   this.adminServiceVisible = true
      //   this.adminAttSumVisible = false
      //   this.adminAttDayVisible = false
      //
      //   this.defaultShowMenu = ['6']
      // }
      // else if(this.$route.params.category == 'workday-table') {
      //   this.$nextTick(() => {
      //     this.$refs.newIcon.style.display = 'initial'
      //     this.$refs.newIconBlue.style.display = 'none'
      //     this.$refs.historyIcon.style.display = 'initial'
      //     this.$refs.historyIconBlue.style.display = 'none'
      //     this.$refs.claimIcon.style.display = 'initial'
      //     this.$refs.claimIconBlue.style.display = 'none'
      //     this.$refs.workdayIcon.style.display = 'initial'
      //     this.$refs.workdayIconBlue.style.display = 'none'
      //     this.$refs.hardwareIcon.style.display = 'initial'
      //     this.$refs.hardwareIconBlue.style.display = 'none'
      //   })
      //   this.adminUserVisible = false
      //   this.adminStatusVisible = false
      //   this.adminClaimVisible = false
      //   this.adminWorkdayVisible = false
      //   this.adminHardwareVisible = false
      //   this.adminServiceVisible = false
      //   this.adminAttSumVisible = false
      //   this.adminAttDayVisible = false
      // }
      else if(this.$route.params.category == 'attendance-summary') {
        this.$nextTick(() => {
          this.$refs.newIcon.style.display = 'initial'
          this.$refs.newIconBlue.style.display = 'none'
          this.$refs.historyIcon.style.display = 'initial'
          this.$refs.historyIconBlue.style.display = 'none'
          this.$refs.claimIcon.style.display = 'initial'
          this.$refs.claimIconBlue.style.display = 'none'
          this.$refs.workdayIcon.style.display = 'initial'
          this.$refs.workdayIconBlue.style.display = 'none'
          this.$refs.hardwareIcon.style.display = 'initial'
          this.$refs.hardwareIconBlue.style.display = 'none'
          this.$refs.atteSummaryIcon.style.display = 'none'
          this.$refs.atteSummaryIconBlue.style.display = 'initial'
          this.$refs.atteRecordIcon.style.display = 'initial'
          this.$refs.atteRecordIconBlue.style.display = 'none'
        })
        this.adminUserVisible = false
        this.adminStatusVisible = false
        this.adminClaimVisible = false
        this.adminWorkdayVisible = false
        this.adminHardwareVisible = false
        this.adminServiceVisible = false
        this.adminAttSumVisible = true
        this.adminAttDayVisible = false

        this.getAttSummary()
        this.getAttendanceSummaryByYear()
        this.defaultShowMenu = ['6']
      }else if(this.$route.params.category == 'attendance-record') {
        this.$nextTick(() => {
          this.$refs.newIcon.style.display = 'initial'
          this.$refs.newIconBlue.style.display = 'none'
          this.$refs.historyIcon.style.display = 'initial'
          this.$refs.historyIconBlue.style.display = 'none'
          this.$refs.claimIcon.style.display = 'initial'
          this.$refs.claimIconBlue.style.display = 'none'
          this.$refs.workdayIcon.style.display = 'initial'
          this.$refs.workdayIconBlue.style.display = 'none'
          this.$refs.hardwareIcon.style.display = 'initial'
          this.$refs.hardwareIconBlue.style.display = 'none'
          this.$refs.atteSummaryIcon.style.display = 'initial'
          this.$refs.atteSummaryIconBlue.style.display = 'none'
          this.$refs.atteRecordIcon.style.display = 'none'
          this.$refs.atteRecordIconBlue.style.display = 'initial'
        })
        this.adminUserVisible = false
        this.adminStatusVisible = false
        this.adminClaimVisible = false
        this.adminWorkdayVisible = false
        this.adminHardwareVisible = false
        this.adminServiceVisible = false
        this.adminAttSumVisible = false
        this.adminAttDayVisible = true

        this.getAttRecord()
        this.defaultShowMenu = ['7']
      }


    }
    
  },
  created() {
    if (localStorage.impr_id && localStorage.impr_token) {
      this.avatar = localStorage.impr_picture
      this.curUserId = localStorage.impr_id

      this.getNewEeId()
      this.getGroupList()
      this.getteamStructureList()
      this.getJobTitle()
      this.getManageList()
      this.getServerStatus()
      // this.getAttSummary()
      // this.getAttRecord()

      this.$post(api.tool.getAllBalance, {
        timestamp: Date.parse(new Date()),
        token: localStorage.impr_token,
        employee_id: this.curUserId,
        year:this.yearValue,
      }).then((res) => {
        if (res.code === 200) {
          this.workdayList = res.list
        }
      })


      this.initPage()
    } else {
      this.$router.push({ path: '/' })
    }
  },

}
</script>
<style scoped>
/* Common */
#components-layout-demo-basic .ant-layout {
  background: #fff;
}
#components-layout-demo-basic .ant-layout-header,
#components-layout-demo-basic .ant-layout-footer {
  height: 55px;
  padding: 0;
  background: #fff;
  color: #000;
}
#components-layout-demo-basic .ant-layout-content {
  background: #fff;
  color: #fff;
  min-height: 1145px;
}

.container {
  min-width: 1024px;
  padding:0 20px 0 30px;
  height: 100%;
  margin: 0 auto;
  display: flex;
  color: #000;
}

.clearfix {
  content: '';
  display: block;
  clear: both;
}

/* Logo */
.logo span {
  line-height: 38px;
  margin-left: 10px;
  vertical-align: top;
  font-family: GoogleSans-Medium;
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  color: #1a73e8;
}

/* tab */
#components-layout-demo-basic >>> .ant-menu-vertical {
  border-right: 0;
  margin-top: 24px;
}
#components-layout-demo-basic >>> .ant-menu-item {
  height: 44px;
  width: 280px;
  background-color: #ffffff;
  border-radius: 0 22px 22px 0;
  padding-top: 1px;
  padding-left:5px;
}
#components-layout-demo-basic >>> .ant-menu-item span {
  font-family: GoogleSans-Medium;
  font-size: 14px;
  color: #222222;
  margin-left: 16px;
}
#components-layout-demo-basic >>> .ant-menu-item-selected {
  background-color: #e9f0fd;
  border-radius: 0 22px 22px 0;
}
#components-layout-demo-basic >>> .ant-menu-item-selected span {
  font-family: GoogleSans-Medium;
  font-size: 14px;
  color: #1a73e8;
}

/* avatar name */
.info-prof {
  height: 81px;
}
.info-prof-avatar {
  margin-top: 5px;
  margin-left: 4px;
  width: 72px;
  height: 72px;
}
.info-prof-avatar img {
  height: 100%;
  width: 100%;
  border-radius: 50%;

}
.info-prof-name {
  height: 16px;
  font-family: GoogleSans-Medium;
  font-size: 20px;
  line-height: 19px;
  color: #222222;
  margin-top: 23px;
}
.info-prof-offer {
  height: 12px;
  font-family: GoogleSans-Regular;
  font-size: 14px;
  line-height: 19px;
  color: #555555;
  margin-top: 10px;
}

.admin {
  display: flex;
  margin-top: 40px;
}
.admin-menu {
  width: 320px;
}
.admin-wrap {
  background-color: #ffffff;
  box-shadow: 0px 0px 12px 1px rgba(17, 17, 17, 0.06);
  border-radius: 8px;
  width: 800px;
}
.admin-status-wrap {
  background-color: #ffffff;
  box-shadow: 0px 0px 12px 1px rgba(17, 17, 17, 0.06);
  border-radius: 8px;
  width: 100%;
  min-width:1024px;
  max-width:1300px;
}
.admin-status-wrap.user-management {
  max-width: none;
}
.new-user {
  min-height: 111px;
  width: 800px;
  border-radius: 8px;
}
.new-user-title,
.user-status-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 85px;
  width: 100%;
  border-bottom: 1px solid #eeeeee;
  color: #222222;

}
.user-new {
  font-family: GoogleSans-Bold;
  font-size: 28px;
  margin-left: 32px;
}
.user-history {
  font-family: GoogleSans-Bold;
  font-size: 16px;
  color: #2177e9;
  margin-right:32px;
}
.new-report-title .user-new {
  font-family: GoogleSans-Bold;
  font-size: 28px;
  margin-top: 22px;
  margin-left: 31px;
}
.new-user-content-1,
.new-user-content-2,
.new-user-content-3 {
  /* height: 555px; */
  width: 100%;
  border-bottom: 1px solid #eeeeee;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding:24px 32px;
}
.user-status-content {
  /* height: 100%; */
  height: 793px;
  width: 100%;
  padding-left: 32px;
  padding-right: 32px;
  padding-top: 24px;
}
.new-user-content-2 {
  height: 444px;
}
.new-user-content-3 {
  height: 122px;
}
.content-item {
  height: 67px;
  width: 356px;
  position: relative;
  margin-top:24px;
}
#components-layout-demo-basic >>> .ant-calendar-picker-icon {
  display: none;
}
#components-layout-demo-basic >>> .ant-select-selection {
  margin-top: 8px;
  height: 40px;
  /* width:356px; */
  font-family: GoogleSans-Regular;
  font-size: 14px;
  /*color: #bbbbbb;*/
  background-color: transparent;
  border-radius: 8px;
  border: 1px solid #e5e5e5;
  padding-left: 6px;
}
#components-layout-demo-basic >>> .auto-name .ant-select-selection {
  padding-left:0;
  border:none;
}
#components-layout-demo-basic >>> .type-select .ant-select-selection {
  padding-left: 0px;
  height: 28px;
}
#components-layout-demo-basic >>> .type-select .ant-select-selection__rendered {
  line-height: 36px;
}
#components-layout-demo-basic >>> .ant-select-disabled .ant-select-selection {
  background: transparent;
}

#components-layout-demo-basic >>> .tree-select.ant-select-disabled .ant-select-selection.ant-select-selection--single,
#components-layout-demo-basic >>> .content-item .ant-input.ant-input-disabled {
  background-color: #fafafa;
  color: #999999;
}
#components-layout-demo-basic >>> .ant-select-selection--single .ant-select-selection__rendered {
  line-height: 36px;
  font-family: GoogleSans-Regular;
  font-size: 14px;
  /*color: #222222;*/
}
#components-layout-demo-basic >>> .content-item span {
  /* width: 100%; */
  /* height: 40px; */
  font-size: 14px;
  line-height: 19px;
  /* border-radius: 8px; */
}
#components-layout-demo-basic >>> .ant-calendar-picker {
  width: 100%;
}
#components-layout-demo-basic >>> .content-item span.item-title {
  color: #999999;
  height: 40px;
  font-family: GoogleSans-Medium;
  font-size: 14px;
  line-height: 19px;
  /* color: #999999; */
  border-radius: 8px;
}
#components-layout-demo-basic >>> .content-item span.item-title-des {
  font-size: 12px;
  color: #999999;
}
#components-layout-demo-basic >>> .tree-select.ant-select.ant-select-disabled .ant-select-selection__rendered {
  color: #999999;
}
#components-layout-demo-basic >>> .content-item .ant-input {
  margin-top: 10px;
  height: 40px;
  font-family: GoogleSans-Regular;
  font-size: 14px;
  color: #222222;
  background-color: #ffffff;
  border-radius: 8px;
  border: 1px solid #e5e5e5;
  padding-left: 16px;
}
#components-layout-demo-basic >>> .ant-input.disabled-input {
  background-color: #fafafa;
  border-radius: 8px;
  border: 1px solid #e5e5e5;
}
#components-layout-demo-basic >>> .ant-select-selection__placeholder {
  color: #bbbbbb;
}
#components-layout-demo-basic >>> .ant-input::placeholder {
  color: #bbbbbb;
}
.new-user-generate {
  padding-top: 32px;
  padding-left: 32px;
  /* padding-right: 32px; */
  cursor: pointer;
  display: flex;
  justify-content: flex-end;
}
#components-layout-demo-basic >>> .new-user-generate .ant-btn {
  width: 350px;
  /* width:48%; */
  margin-right:32px;
  height: 48px;
  background-color: #2177e9;
  border-radius: 8px;
  border: 1px solid #2177e9;
  font-family: GoogleSans-Medium;
  font-size: 14px;
  color: #ffffff;
  margin-bottom: 32px;
}

#components-layout-demo-basic >>> .ant-checkbox-wrapper span {
  line-height: 50px;
}

#components-layout-demo-basic >>>  .ant-select-arrow {
    width: 0px !important;
    height: 0px !important;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 9px solid #2177e9;
    border-radius: 3px;
    margin-top:-5px;
}
#components-layout-demo-basic >>> .ant-select-arrow i svg {
    display: none;
}
#components-layout-demo-basic >>>  .tree-select .ant-select-selection__rendered {
    padding-top:10px;
}
#components-layout-demo-basic >>> .lunar.ant-checkbox-wrapper {
  display: flex;
  align-items: center;
  /* margin-top:12px; */
}
#components-layout-demo-basic >>> .lunar.ant-checkbox-wrapper span {
  height:16px;
  line-height:19px;
  margin-top:4px;
}
#components-layout-demo-basic >>> .lunar.ant-checkbox-wrapper .ant-checkbox {
  height:16px;
  margin-top:0;
}
#components-layout-demo-basic >>> .lunar.ant-checkbox-wrapper .ant-checkbox.ant-checkbox-checked::after {
  border:none;
}
#components-layout-demo-basic >>> .lunar.ant-checkbox-wrapper .ant-checkbox .ant-checkbox-inner {
  height:16px;
  width:16px;
}
#components-layout-demo-basic >>> .ant-table-tbody .ant-table-row .ant-table-selection-column .ant-checkbox-inner::after,
#components-layout-demo-basic >>> .ant-table-thead .ant-checkbox-inner::after{
  left:21%;
}
#components-layout-demo-basic >>> .ant-table-thead .ant-checkbox-indeterminate .ant-checkbox-inner::after {
  left:50%;
}
.change-item {
  width:100%;
  display: flex;
  align-items: center;
  margin-bottom:20px;
}

/* #components-layout-demo-basic >>> .filter-checkbox-wrap {
  height:40px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}
#components-layout-demo-basic >>> .filter-checkbox-item {
  width:13%;
  margin-top:0;
} */
.view-report-content {
  /* margin-top: 15px; */
}
.report-content-item {
  /* border: 1px solid #eeeeee; */
  border-radius: 8px;
  background-color: #ffffff;
  /* padding-left: 24px; */
  height: 48px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px
}
.content-item-id {
  font-family: GoogleSans-Bold;
  font-size: 14px;
  color: #222222;
}
.content-item-type {
  font-family: GoogleSans-Regular;
  font-size: 14px;
  color: #222222;
}
.content-item-name {
  font-family: GoogleSans-Regular;
  font-size: 14px;
  color: #999999;
}
.export-btn {
  /* width:95px; */
  margin-right:30px;
  border-radius:6px;
}
#components-layout-demo-basic >>> .claim-management .ant-table-row {
  cursor: pointer;
}
#components-layout-demo-basic >>> .invoice-submit-btn {
  width:95px;
  height:40px;
  margin-right:20px;
  letter-spacing:-1px;
  border-radius:8px;
}
#components-layout-demo-basic >>> .ant-table-row.ant-table-row-level-0 .ant-table-row-cell-break-word{
  padding:10px 16px;
}

#components-layout-demo-basic >>> .ant-select.ant-select-enabled {
  width:100%;
}
#components-layout-demo-basic >>> .group-tree > .ant-select-selection > .ant-select-search__field__placeholder {
  margin-top:-6px;
}
#components-layout-demo-basic >>> .group-tree > .ant-select-selection > .ant-select-selection__rendered {
  margin-top:4px;
}
#components-layout-demo-basic >>> .year-select {
  flex:1;
  margin-right:24px;
  height:32px;
}
#components-layout-demo-basic >>> .year-select .ant-select-selection__rendered {
  height:32px;
  line-height:31px;
}
#components-layout-demo-basic >>> .year-select .ant-select-selection {
  height:32px;
  width:90px;
  margin-top:0;
  margin-right:24px;
}
.ant-table-filter-dropdown .ant-dropdown-menu {
  max-height: 100px !important;
}

.participants {
  /* word-break: break-word; */
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}
.participants-item {
  margin-right:5px;
}
.none {
  display: none;
}
</style>
